/*
* 菜鸟云打印组件
*/


let that=this;

 const CN={
    CreatedOKLodopObject:null,
    CLodopIsLocal:null,
    CLodopJsState:null,
    CreatedOKLodop7766:null,

    /*
    * 菜鸟打印组件
    */
    CNPrint : {
     cnSocket: null,
     cnVersion: '1.0',
     defaultPrinter: null,
     printing:false,
     /*
     * 连接菜鸟云打印机
     */
     connectting: function () {
       // 连接Socket
       that.a.CNPrint.cnSocket = new WebSocket('wss://localhost:13529');/*ws://127.0.0.1:13528*/
       switch ( that.a.CNPrint.cnSocket.readyState) {
         case 0:
           console.log('连接WebSocket - 菜鸟客户端中...');
           break;
         case 3:
           console.log('未发现【菜鸟打印组件】,无法打印电子面单！');
           return false;
         default:
           break;
       }

       // 打开Socket
        that.a.CNPrint.cnSocket.onopen = function (event) {
         console.log("连接WebSocket - 菜鸟客户端成功！");
         if (! that.a.CNPrint.defaultPrinter)
           that.a.CNPrint.getPrinters();
       };

       // 监听消息
        that.a.CNPrint.cnSocket.onmessage = function (event) {
         let data = JSON.parse(event.data);
         console.log('监听消息');
         console.log(data);
         switch (data.cmd) {
           case "getPrinters":
              that.a.CNPrint.defaultPrinter = null;
             for (let idx = 0; idx < data.printers.length; idx++) {
               let el = data.printers[idx];
               if (el.name.indexOf(that.a.EBill.printerKeyName) > -1) {
                  that.a.CNPrint.defaultPrinter = el.name;
                 break;
               };
             }

             if ( that.a.CNPrint.defaultPrinter) {
               that.a.CNPrint.setPrinterConfig();
             } else {
               alert('未启用【菜鸟打印组件】,无法打印电子面单！');
               return null;
             }
             break;
           case "setPrinterConfig":
             that.a.CNPrint.print();
             break;
           case "getPrinterConfig":
             let curPaperSize = data.printer.paperSize;
             switch (that.a.EBill.templateType) {
               case 1:/* 一联单 */
                 if (curPaperSize.width == 76 && curPaperSize.height == 130) {
                   that.a.CNPrint.print();
                 } else {
                   that.a.CNPrint.setPrinterConfig(76, 130);
                 }
                 break;
               case 2:/* 二联单 */
               default:
                 if (curPaperSize.width == 100 && curPaperSize.height == 180) {
                   that.a.CNPrint.print();
                 } else {
                   that.a.CNPrint.setPrinterConfig(100, 180);
                 }
                 break;
             }
             break;
           case "print":
             if (typeof (that.a.EBill.callBack) == 'function') {
               that.a.EBill.callBack();
             }
             break;
           case "notifyPrintResult":
              if(data.taskStatus == 'printed'){
                alert("打印成功");
              }
             break;
           default:
             break;
         }

         return null;
       };

       // 监听Socket的关闭
        that.a.CNPrint.cnSocket.onclose = function (event) {
          that.a.CNPrint.defaultPrinter = null;
         console.log('【菜鸟打印组件】已停用,无法打印电子面单！');
         alert('【菜鸟打印组件】已停用,无法打印电子面单！');
         if (typeof (that.a.EBill.callBack) == 'function') {
           that.a.EBill.callBack();
         }
       };

        that.a.CNPrint.cnSocket.onerror = function (event) {
         console.log('无法连接到WebSocket - 菜鸟客户端！');
       };
     },
     /*
      * 请求打印机列表协议
      */
     getPrinters: function () {
       let request = {
         requestID: '' + new Date().getTime(),
         version:  that.a.CNPrint.cnVersion,
         cmd: "getPrinters"
       };
        that.a.CNPrint.cnSocket.send(JSON.stringify(request));
     },
     /*
      * 请求打印机设置协议
      */
     setPrinterConfig: function (pageWidth, pageHeight) {
       switch (that.a.EBill.templateType) {
         case 1://一联单
           if (!!!pageWidth) {
             pageWidth = 76
           }
           if (!!!pageHeight) {
             pageHeight = 130
           }
           break;
         case 2://二联单
         default:
           if (!!!pageWidth) {
             pageWidth = 100
           }
           if (!!!pageHeight) {
             pageHeight = 180
           }
           break;
       }

       let request = {
         requestID: '' + new Date().getTime(),
         version: that.a.CNPrint.cnVersion,
         cmd: "setPrinterConfig",
         printer: {
           name:  that.a.CNPrint.defaultPrinter,
           needTopLogo: true,
           needBottomLogo: true,
           horizontalOffset: 0,
           verticalOffset: 0,
           forceNoPageMargins: true,
           autoOrientation: true,
           orientation: 0,
           paperSize: {
             width: pageWidth,
             height: pageHeight
           }
         }
       };

       let taskStr = JSON.stringify(request);
       console.log(taskStr);
       that.a.CNPrint.cnSocket.send(taskStr);
     },
     /*
      * 请求获取打印机设置
      */
     getPrinterConfig: function () {
       let request = {
         requestID: '' + new Date().getTime(),
         version:  that.a.CNPrint.cnVersion,
         cmd: "getPrinterConfig",
         printer:  that.a.CNPrint.defaultPrinter
       };

       that.a.CNPrint.cnSocket.send(JSON.stringify(request));
     },
     /*
      * 打印
      */
     print: function () {
       if (! that.a.CNPrint.cnSocket) {
         alert('未启用【菜鸟打印组件】,无法打印电子面单！');
         return false;
       }

       if (! that.a.CNPrint.defaultPrinter) {
         alert('未启用【菜鸟打印组件】,无法打印电子面单！');
         return false;
       }

       let isPreview = false;
       switch ( that.a.CNPrint.printType) {
         case 1: /*预览*/
           isPreview = true;
           break;
         case 2: /*打印*/
         default:
           isPreview = false;
           break;
       }

       let jsons = that.a.EBill.objJson;
       if (Object.prototype.toString.call(jsons) != '[object Array]' || jsons.length == 0) {
         return false;
       }

       for (let cnIndex = 0; cnIndex < jsons.length; cnIndex++) {
         let objJson = jsons[cnIndex];

         let custAreaUrl = objJson.CustomAreaUrl;
         let objRes = eval('(' + objJson.Response + ')');
         let objData = eval('(' + objRes.PrintData + ')');

         let contArea = [
           //电子面单部分
           {
             data: objData.data,
             encryptedData: objData.encryptedData,
             signature: objData.signature,
             templateURL: objData.templateUrl != null && objData.templateUrl != "" ? objData.templateUrl : objData.templateURL,
             ver: objData.ver,
             addData: objData.addData
           },
           //自定义区部分
           {
             templateURL: custAreaUrl,
             data: {
               item_list: objJson.ListInfo,
               item_count: objJson.ProCount,
               order_code: objJson.OrderCode,
               delivery_mode: objJson.Delivery,
               delivery_id: objJson.DeliveryId,
               check_user: objJson.Shelves,
               plat_name: "【云】"
             }
           }
         ]

         let taskDocs = [{
           documentID: objJson.WaybillCode,
           contents: contArea
         }];

         let request = {
           cmd: "print",
           requestID: '' + new Date().getTime()+"_"+cnIndex,
           version:  that.a.CNPrint.cnVersion,
           task: {
             taskID: '菜鸟云打印 - ' + objJson.OrderCode + ' - ' + new Date().getTime()+"_"+cnIndex,
             preview: isPreview,
             printer:  that.a.CNPrint.defaultPrinter,
             documents: taskDocs
           }
         };

         let taskStr = JSON.stringify(request);
         console.log(taskStr);
         that.a.CNPrint.printing=true;
         that.a.CNPrint.cnSocket.send(taskStr);
         that.a.CNPrint.printing=false;


       }

       return true;
     }
    },

    /*
     * 拼多多云打印组件
     */
    PDDPrint : {
      pddSocket: null,
      pddVersion: '1.0',
      defaultPrinter: null,
      /*
      * 连接菜鸟云打印机
      */
      connectting: function () {
        // 连接Socket
        that.a.PDDPrint.pddSocket = new WebSocket('wss://127.0.0.1:18653');/*ws://127.0.0.1:5000*/
        switch (that.a.PDDPrint.pddSocket.readyState) {
          case 0:
            console.log('连接WebSocket - 拼多多客户端中...');
            break;
          case 3:
            console.log('未发现【拼多多打印组件】,无法打印电子面单！');
            return false;
          default:
            break;
        }

        // 打开Socket
        that.a.PDDPrint.pddSocket.onopen = function (event) {
          console.log("连接WebSocket - 拼多多客户端成功！");
          if (!that.a.PDDPrint.defaultPrinter)
            that.a.PDDPrint.getPrinters();
        };

        // 监听消息
        that.a.PDDPrint.pddSocket.onmessage = function (event) {
          let data = JSON.parse(event.data);
          //console.log(data);
          switch (data.cmd) {
            case "getPrinters":
              that.a.PDDPrint.defaultPrinter = null;
              for (let idx = 0; idx < data.printers.length; idx++) {
                let el = data.printers[idx];
                if (el.name.indexOf(that.a.EBill.printerKeyName) > -1) {
                  that.a.PDDPrint.defaultPrinter = el.name;
                  break;
                };
              }

              if (that.a.PDDPrint.defaultPrinter) {
                that.a.PDDPrint.print();
              } else {
                alert('未启用【拼多多打印组件】,无法打印电子面单！');
                return null;
              }
              break;
            case "setPrinterConfig":
              that.a.PDDPrint.print();
              break;
            case "getPrinterConfig":
              /* 因拼多多设置打印机时，会恢复面单纸的宽、高和非打印区域左、右的默认值 */
              that.a.PDDPrint.print();
              /*
              let curPaperSize = data.printer.paperSize;
              switch (EBill.templateType) {
                  case 1://一联单
                      if (curPaperSize.width == 760 && curPaperSize.height == 1300) {
                          that.a.PDDPrint.print();
                      } else {
                          that.a.PDDPrint.setPrinterConfig(760, 1300);
                      }
                      break;
                  case 2://二联单
                  default:
                      if (curPaperSize.width == 1000 && curPaperSize.height == 1800) {
                          that.a.PDDPrint.print();
                      } else {
                          that.a.PDDPrint.setPrinterConfig(1000, 1800);
                      }
                      break;
              }
              */
              break;
            case "print":
              if (typeof (EBill.callBack) == 'function') {
                EBill.callBack();
              }
              break;
            case "notifyPrintResult":
              if(data.taskStatus == 'printed'){
                alert("打印成功");
              }
              break;
            default:
              break;
          }

          return null;
        };

        // 监听Socket的关闭
        that.a.PDDPrint.pddSocket.onclose = function (event) {
          that.a.PDDPrint.defaultPrinter = null;
          console.log('【拼多多打印组件】已停用,无法打印电子面单！');
          alert('【拼多多打印组件】已停用,无法打印电子面单！');
          if (typeof (that.a.EBill.callBack) == 'function') {
            that.a.EBill.callBack();
          }
        };

        that.a.PDDPrint.pddSocket.onerror = function (event) {
          console.log('无法连接到WebSocket - 拼多多客户端！');
        };
      },
      /*
       * 请求打印机列表协议
       */
      getPrinters: function () {
        let request = {
          requestID: '' + new Date().getTime(),
          version: that.a.PDDPrint.pddVersion,
          cmd: "getPrinters"
        };
        that.a.PDDPrint.pddSocket.send(JSON.stringify(request));
      },
      /*
       * 请求打印机设置协议
       */
      setPrinterConfig: function (pageWidth, pageHeight) {
        switch (that.a.EBill.templateType) {
          case 1://一联单
            if (!!!pageWidth) {
              pageWidth = 760
            }
            if (!!!pageHeight) {
              pageHeight = 1300
            }
            break;
          case 2://二联单
          default:
            if (!!!pageWidth) {
              pageWidth = 1000
            }
            if (!!!pageHeight) {
              pageHeight = 1800
            }
            break;
        }

        let request = {
          requestID: '' + new Date().getTime(),
          version: that.a.PDDPrint.pddVersion,
          cmd: "setPrinterConfig",
          printer: {
            name: that.a.PDDPrint.defaultPrinter,
            PrintTopLogo: true,
            PrintBottomLogo: true,
            horizontalOffset: 0,
            verticalOffset: 0,
            forceNoPageMargins: true,
            autoOrientation: true,
            orientation: 0,
            paperSize: {
              width: pageWidth,
              height: pageHeight
            }
          }
        };

        let taskStr = JSON.stringify(request);
        console.log(taskStr);
        that.a.PDDPrint.pddSocket.send(taskStr);
      },
      /*
    * 请求获取打印机设置
    */
      getPrinterConfig: function () {
        let request = {
          requestID: '' + new Date().getTime(),
          version: that.a.PDDPrint.pddVersion,
          cmd: "getPrinterConfig",
          printer: that.a.PDDPrint.defaultPrinter
        };

        that.a.PDDPrint.pddSocket.send(JSON.stringify(request));
      },
      /*
       * 打印
       */
      print: function () {
        if (!that.a.PDDPrint.pddSocket) {
          alert('未启用【拼多多打印组件】,无法打印电子面单！');
          return false;
        }

        if (!that.a.PDDPrint.defaultPrinter) {
          alert('未启用【拼多多打印组件】,无法打印电子面单！');
          return false;
        }

        let isPreview = false;
        switch (that.a.PDDPrint.printType) {
          case 1: /*预览*/
            isPreview = true;
            break;
          case 2: /*打印*/
          default:
            isPreview = false;
            break;
        }

        let jsons = that.a.EBill.objJson;
        if (Object.prototype.toString.call(jsons) != '[object Array]' || jsons.length == 0) {
          return false;
        }

        for (let cnIndex = 0; cnIndex < jsons.length; cnIndex++) {
          let objJson = jsons[cnIndex];

          let custAreaUrl = objJson.CustomAreaUrl;
          let objRes = eval('(' + objJson.Response + ')');
          let objData = eval('(' + objRes.print_data + ')');

          let contArea = [
            //电子面单部分
            {
              data: objData.data,
              encryptedData: objData.encryptedData,
              signature: objData.signature,
              templateURL: objData.templateUrl != null && objData.templateUrl != "" ? objData.templateUrl : objData.templateURL,
              ver: objData.ver,
              addData: objData.addData
            },
            //自定义区部分
            {
              templateURL: custAreaUrl,
              data: {
                item_list: objJson.ListInfo,
                item_count: objJson.ProCount,
                order_code: objJson.OrderCode,
                delivery_mode: objJson.Delivery,
                delivery_id: objJson.DeliveryId,
                check_user: objJson.Shelves,
                plat_name: "【云】"
              }
            }
          ]

          let taskDocs = [{
            documentID: objJson.WaybillCode,
            contents: contArea
          }];

          let request = {
            cmd: "print",
            requestID: '' + new Date().getTime(),
            version: that.a.PDDPrint.pddVersion,
            task: {
              taskID: '拼多多云打印 - ' + objJson.OrderCode + ' - ' + new Date().getTime()+"_"+cnIndex,
              preview: isPreview,
              printer: that.a.PDDPrint.defaultPrinter,
              documents: taskDocs
            }
          };

          let taskStr = JSON.stringify(request);
          console.log(taskStr);
          that.a.PDDPrint.pddSocket.send(taskStr);
        }

        return true;
      }
    },

    /*
     * 抖店打印组件
     */
    DDPrint : {
        ddSocket: null,
        ddVersion: '1.0',
        defaultPrinter: null,
        /*
        * 连接菜鸟云打印机
        */
        connectting: function () {
            // 连接Socket
            that.a.DDPrint.ddSocket = new WebSocket('wss://127.0.0.1:13999');/* ws://127.0.0.1:13888 */
            switch (that.a.DDPrint.ddSocket.readyState) {
                case 0:
                    console.log('连接WebSocket - 抖店客户端中...');
                    break;
                case 3:
                    console.log('未发现【抖店打印组件】,无法打印电子面单！');
                    return false;
                default:
                    break;
            }

            // 打开Socket
            that.a.DDPrint.ddSocket.onopen = function (event) {
                console.log("连接WebSocket - 抖店客户端成功！");
                if (!that.a.DDPrint.defaultPrinter)
                    that.a.DDPrint.getPrinters();
            };

            // 监听消息
            that.a.DDPrint.ddSocket.onmessage = function (event) {
                let data = JSON.parse(event.data);
                //console.log(data);
                switch (data.cmd) {
                    case "getPrinters":
                        that.a.DDPrint.defaultPrinter = null;
                        for (let idx = 0; idx < data.printers.length; idx++) {
                            let el = data.printers[idx];
                            if (el.name.indexOf(that.a.EBill.printerKeyName) > -1) {
                                that.a.DDPrint.defaultPrinter = el.name;
                                break;
                            };
                        }

                        if (that.a.DDPrint.defaultPrinter) {
                            that.a.DDPrint.print();
                        } else {
                            alert('未启用【抖店打印组件】,无法打印电子面单！');
                            return null;
                        }
                        break;
                    case "setPrinterConfig":
                        that.a.DDPrint.print();
                        break;
                    case "getPrinterConfig":
                        /* 因抖店设置打印机时，会恢复面单纸的宽、高和非打印区域左、右的默认值 */
                        that.a.DDPrint.print();
                        /*
                        let curPaperSize = data.printer.paperSize;
                        switch (that.a.EBill.templateType) {
                            case 1://一联单
                                if (curPaperSize.width == 760 && curPaperSize.height == 1300) {
                                    that.a.DDPrint.print();
                                } else {
                                    that.a.DDPrint.setPrinterConfig(760, 1300);
                                }
                                break;
                            case 2://二联单
                            default:
                                if (curPaperSize.width == 1000 && curPaperSize.height == 1800) {
                                    that.a.DDPrint.print();
                                } else {
                                    that.a.DDPrint.setPrinterConfig(1000, 1800);
                                }
                                break;
                        }
                        */
                        break;
                    case "print":
                        if (typeof (that.a.EBill.callBack) == 'function') {
                            that.a.EBill.callBack();
                        }
                        break;
                    case "notifyPrintResult":

                        break;
                    default:
                        break;
                }

                return null;
            };

            // 监听Socket的关闭
            that.a.DDPrint.ddSocket.onclose = function (event) {
                that.a.DDPrint.defaultPrinter = null;
                console.log('【抖店打印组件】已停用,无法打印电子面单！');
                alert('【抖店打印组件】已停用,无法打印电子面单！');
                if (typeof (that.a.EBill.callBack) == 'function') {
                    that.a.EBill.callBack();
                }
            };

            that.a.DDPrint.ddSocket.onerror = function (event) {
                console.log('无法连接到WebSocket - 抖店客户端！');
            };
        },

        /*
         * 请求打印机列表协议
         */
        getPrinters: function () {
            let request = {
                requestID: '' + new Date().getTime(),
                version: that.a.DDPrint.ddVersion,
                cmd: "getPrinters"
            };
            that.a.DDPrint.ddSocket.send(JSON.stringify(request));
        },
        /*
         * 请求打印机设置协议
         */
        setPrinterConfig: function (pageWidth, pageHeight) {
            switch (that.a.EBill.templateType) {
                case 1://一联单
                    if (!!!pageWidth) {
                        pageWidth = 760
                    }
                    if (!!!pageHeight) {
                        pageHeight = 1300
                    }
                    break;
                case 2://二联单
                default:
                    if (!!!pageWidth) {
                        pageWidth = 1000
                    }
                    if (!!!pageHeight) {
                        pageHeight = 1800
                    }
                    break;
            }

            let request = {
                requestID: '' + new Date().getTime(),
                version: that.a.DDPrint.ddVersion,
                cmd: "setPrinterConfig",
                printer: {
                    name: that.a.DDPrint.defaultPrinter,
                    PrintTopLogo: true,
                    PrintBottomLogo: true,
                    horizontalOffset: 0,
                    verticalOffset: 0,
                    forceNoPageMargins: true,
                    autoOrientation: true,
                    orientation: 0,
                    paperSize: {
                        width: pageWidth,
                        height: pageHeight
                    }
                }
            };

            let taskStr = JSON.stringify(request);
            console.log(taskStr);
            that.a.DDPrint.ddSocket.send(taskStr);
        },
        /*
         * 请求获取打印机设置
         */
        getPrinterConfig: function () {
            let request = {
                requestID: '' + new Date().getTime(),
                version: that.a.DDPrint.ddVersion,
                cmd: "printerConfig"
                //printer: that.a.DDPrint.defaultPrinter
            };

            that.a.DDPrint.ddSocket.send(JSON.stringify(request));
        },
        /*
         * 打印
         */
        print: function () {
            if (!that.a.DDPrint.ddSocket) {
                alert('未启用【抖店打印组件】,无法打印电子面单！');
                return false;
            }

            if (!that.a.DDPrint.defaultPrinter) {
                alert('未启用【抖店打印组件】,无法打印电子面单！');
                return false;
            }

            let isPreview = false;
            switch (that.a.DDPrint.printType) {
                case 1: /*预览*/
                    isPreview = true;
                    break;
                case 2: /*打印*/
                default:
                    isPreview = false;
                    break;
            }

            let jsons = that.a.EBill.objJson;
            if (Object.prototype.toString.call(jsons) != '[object Array]' || jsons.length == 0) {
                return false;
            }

            for (let cnIndex = 0; cnIndex < jsons.length; cnIndex++) {
                let objJson = jsons[cnIndex];

                let custAreaUrl = objJson.CustomAreaUrl;
                let objRes = eval('(' + objJson.Response + ')');
                let objData = eval('(' + objRes.print_data + ')');

                let contArea = [
                    //电子面单部分
                    {
                        params: objData.params,
                        encryptedData: objData.encryptedData,
                        templateURL: objData.templateUrl != null && objData.templateUrl != "" ? objData.templateUrl : objData.templateURL,
                        signature: objData.signature,
                        addData: objData.addData
                    },
                    //自定义区部分
                    {
                        templateURL: custAreaUrl,
                        data: {
                            item_list: objJson.ListInfo,
                            item_count: objJson.ProCount,
                            order_code: objJson.OrderCode,
                            delivery_mode: objJson.Delivery,
                            delivery_id: objJson.DeliveryId,
                            check_user: objJson.Shelves,
                            plat_name: "【云】",
                            productCount: objJson.ProCount
                        }
                    }
                ]

                let taskDocs = [{
                    documentID: objJson.WaybillCode,
                    contents: contArea
                }];

                let request = {
                    cmd: "print",
                    requestID: '' + new Date().getTime(),
                    version: that.a.DDPrint.ddVersion,
                    task: {
                        taskID: '抖店云打印 - ' + objJson.OrderCode + ' - ' + new Date().getTime(),
                        preview: isPreview,
                        printer: that.a.DDPrint.defaultPrinter,
                        documents: taskDocs
                    }
                };

                let taskStr = JSON.stringify(request);
                console.log(taskStr);
                that.a.DDPrint.ddSocket.send(taskStr);
            }

            return true;
        }
    },

    /*
    * 整数时缺省长度单位为0.1毫米,字符型时可包含单位名：in(英寸)、cm(厘米) 、mm(毫米) 、pt(磅)、px(1/96英寸)
    */
    EBill : {
    printerKeyName: "电子面单", /*电子面单打印机的关键词*/
    findMachine: false,         /*打印控件对象*/
    objJson: null,
    printType: 1,               /*1：预览，2：打印*/
    templateType: 1,            /*1：一联单，2：二联单*/
    callBack: function () {

    },
    LodopPrint: function (LODOP, objJson) {
      switch (objJson.TemplateType)
      {
        case 1:
        {
          LODOP.PRINT_INITA(0, 0, "76mm", "130mm", "LODOP一联单" + (objJson.OrderId == null || objJson.OrderId == "" ? "" : " - " + objJson.OrderId));
          LODOP.SET_PRINT_PAGESIZE(0, "76mm", "130mm", "");

          LODOP.ADD_PRINT_IMAGE(2, 5, "40mm", "17.99mm", "URL:" + objJson.CpLogoUp);
          LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);
          LODOP.ADD_PRINT_BARCODE(9, 150, "59mm", "15mm", objJson.CodecType, objJson.WaybillCode);
          LODOP.ADD_PRINT_LINE(68, -1, 68, 1005, 0, 1);
          LODOP.ADD_PRINT_TEXT(73, 14, 54, 23, "目的地");
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          LODOP.ADD_PRINT_TEXT(71, 70, 245, 32, objJson.ShortAddress);
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          LODOP.ADD_PRINT_TEXT(75, 312, 64, 24, "已验视");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
          LODOP.SET_PRINT_STYLEA(0, "TextFrame", 13);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", 2);
          LODOP.ADD_PRINT_LINE(100, -5, 100, 385, 0, 1);
          LODOP.ADD_PRINT_TEXT(104, 70, 200, 46, objJson.PackageCenterName);
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          if (objJson.PackageCenterCode != null && objJson.PackageCenterCode != "") {
            LODOP.ADD_PRINT_BARCODE(104, 276, 100, 40, objJson.CodecType, objJson.PackageCenterCode);
          }
          LODOP.ADD_PRINT_TEXT(114, 14, 54, 20, "集包地");
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          LODOP.ADD_PRINT_LINE(146, -1, 146, 1005, 0, 1);
          LODOP.ADD_PRINT_LINE(146, 64, 68, 65, 0, 1);
          LODOP.ADD_PRINT_LINE(146, 32, 390, 32, 0, 1);

          LODOP.ADD_PRINT_TEXT(175, 14, 20, 48, "收件人");
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          LODOP.ADD_PRINT_TEXT(153, 35, 40, 20, "姓名:");
          LODOP.ADD_PRINT_TEXT(153, 75, 200, 20, objJson.ConsigneeName);
          LODOP.ADD_PRINT_TEXT(150, 282, 96, 20, "签收/代收件签:");
          LODOP.ADD_PRINT_TEXT(171, 35, 40, 20, "电话:");
          LODOP.ADD_PRINT_TEXT(171, 75, 200, 20, objJson.ConsigneePhone);
          LODOP.ADD_PRINT_TEXT(191, 35, 40, 20, "地址:");
          LODOP.ADD_PRINT_TEXT(191, 75, 203, 58, objJson.ConsigneeAddress);
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
          LODOP.ADD_PRINT_TEXT(235, 286, 96, 20, "    年  月  日");
          LODOP.ADD_PRINT_LINE(249, -1, 249, 1005, 0, 1);
          LODOP.ADD_PRINT_LINE(249, 280, 145, 280, 0, 1);

          LODOP.ADD_PRINT_TEXT(256, 14, 20, 48, "寄件人");
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          LODOP.ADD_PRINT_TEXT(256, 35, 40, 20, "姓名:");
          LODOP.ADD_PRINT_TEXT(256, 75, 124, 20, objJson.SendName);
          LODOP.ADD_PRINT_TEXT(256, 240, 40, 20, "电话:");
          LODOP.ADD_PRINT_TEXT(256, 280, 100, 20, objJson.SendPhone);
          LODOP.ADD_PRINT_TEXT(275, 35, 40, 20, "地址:");
          LODOP.ADD_PRINT_TEXT(275, 75, 284, 20, objJson.ShippingAddress);
          LODOP.ADD_PRINT_TEXT(294, 35, 64, 20, "寄件日期:");
          LODOP.ADD_PRINT_TEXT(294, 99, 107, 20, objJson.ExtSendDate);
          LODOP.ADD_PRINT_LINE(311, -1, 311, 1005, 0, 1);

          LODOP.ADD_PRINT_TEXT(320, 14, 20, 58, "内件品名");
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          LODOP.ADD_PRINT_TEXT(315, 35, 345, 78, objJson.ListInfo);
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
          if (objJson.ProCount != null && objJson.ProCount != "") {
            LODOP.ADD_PRINT_TEXT(375, 323, 40, 20, objJson.ProCount);
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
            LODOP.ADD_PRINT_TEXT(377, 308, 63, 20, "共    件");
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
            LODOP.SET_PRINT_STYLEA(0, "Horient", 1);
          }
          LODOP.ADD_PRINT_LINE(390, -1, 390, 1005, 0, 1);

          if (objJson.ExtCustomCode != null && objJson.ExtCustomCode != "") {
            LODOP.ADD_PRINT_TEXT(395, 14, 30, 20, "LC:");
            LODOP.ADD_PRINT_TEXT(395, 40, 150, 20, objJson.ExtCustomCode);
          }
          if (objJson.ServCodAmount != null && objJson.ServCodAmount != "") {
            LODOP.ADD_PRINT_TEXT(395, 196, 63, 20, "代收金额:");
            LODOP.ADD_PRINT_TEXT(391, 256, 150, 20, objJson.ServCodAmount);
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
          }


          LODOP.ADD_PRINT_IMAGE(418, 5, "40mm", "17.99mm", "URL:" + objJson.CpLogoDown);
          LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);
          LODOP.ADD_PRINT_BARCODE(426, 150, "59mm", "15mm", objJson.CodecType, objJson.WaybillCode);
          LODOP.ADD_PRINT_LINE(484, -1, 484, 1005, 0, 1);
          LODOP.ADD_PRINT_LINE(484, 32, 607, 32, 0, 1);
          LODOP.ADD_PRINT_TEXT(486, 35, 40, 20, "姓名:");
          LODOP.ADD_PRINT_TEXT(486, 75, 100, 20, objJson.ConsigneeName);
          LODOP.ADD_PRINT_TEXT(486, 188, 40, 20, "电话:");
          LODOP.ADD_PRINT_TEXT(486, 228, 150, 20, objJson.ConsigneePhone);
          LODOP.ADD_PRINT_TEXT(493, 14, 20, 48, "收件人");
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          LODOP.ADD_PRINT_TEXT(506, 35, 40, 20, "地址:");
          LODOP.ADD_PRINT_TEXT(506, 75, 303, 45, objJson.ConsigneeAddress);
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
          LODOP.ADD_PRINT_LINE(549, -1, 549, 1005, 0, 1);
          LODOP.ADD_PRINT_TEXT(552, 14, 20, 48, "寄件人");
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          LODOP.ADD_PRINT_TEXT(553, 35, 39, 25, "姓名:");
          LODOP.ADD_PRINT_TEXT(553, 75, 100, 20, objJson.SendName);
          LODOP.ADD_PRINT_TEXT(553, 242, 39, 20, "电话:");
          LODOP.ADD_PRINT_TEXT(553, 281, 97, 20, objJson.SendPhone);
          LODOP.ADD_PRINT_TEXT(570, 35, 39, 20, "地址:");
          LODOP.ADD_PRINT_TEXT(570, 75, 300, 20, objJson.ShippingAddress);
          LODOP.ADD_PRINT_TEXT(588, 35, 64, 20, "寄件日期:");
          LODOP.ADD_PRINT_TEXT(588, 99, 282, 20, objJson.ExtSendDate);
          LODOP.ADD_PRINT_LINE(607, -1, 607, 1005, 0, 1);
          LODOP.ADD_PRINT_TEXT(648, 4, 27, 20, "No:");
          LODOP.ADD_PRINT_TEXT(648, 26, 108, 20, "【云】" + objJson.OrderCode);
          if (objJson.Delivery != null && objJson.Delivery != "") {
            LODOP.ADD_PRINT_TEXT(648, 135, 118, 20, objJson.Delivery);
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          }
          if (objJson.Shelves != null && objJson.Shelves != "") {
            LODOP.ADD_PRINT_TEXT(648, 254, 70, 20, objJson.Shelves);
          }
          LODOP.ADD_PRINT_TEXT(647, 325, 70, 20, "已验视");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
        }
          break;
        case 2:
        default:
        {
          LODOP.PRINT_INITA(0, 0, "100mm", "180mm", "LODOP标准面单" + (objJson.OrderId == null || objJson.OrderId == "" ? "" : " - " + objJson.OrderId));
          LODOP.SET_PRINT_PAGESIZE(0, "100mm", "180mm", "");

          LODOP.ADD_PRINT_IMAGE(2, 5, "40mm", "17.99mm", "URL:" + objJson.CpLogoUp);
          LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);
          LODOP.ADD_PRINT_BARCODE(9, 150, "59mm", "15mm", objJson.CodecType, objJson.WaybillCode);
          LODOP.ADD_PRINT_LINE(68, -1, 68, 1005, 0, 1);
          LODOP.ADD_PRINT_TEXT(73, 14, 54, 23, "目的地");
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          LODOP.ADD_PRINT_TEXT(71, 70, 245, 32, objJson.ShortAddress);
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          LODOP.ADD_PRINT_TEXT(75, 312, 64, 24, "已验视");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
          LODOP.SET_PRINT_STYLEA(0, "TextFrame", 13);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", 2);
          LODOP.ADD_PRINT_LINE(100, -5, 100, 385, 0, 1);
          LODOP.ADD_PRINT_TEXT(104, 70, 200, 46, objJson.PackageCenterName);
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          if (objJson.PackageCenterCode != null && objJson.PackageCenterCode != "") {
            LODOP.ADD_PRINT_BARCODE(104, 276, 100, 40, objJson.CodecType, objJson.PackageCenterCode);
          }
          LODOP.ADD_PRINT_TEXT(114, 14, 54, 20, "集包地");
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          LODOP.ADD_PRINT_LINE(146, -1, 146, 1005, 0, 1);
          LODOP.ADD_PRINT_LINE(146, 64, 68, 65, 0, 1);
          LODOP.ADD_PRINT_LINE(146, 32, 390, 32, 0, 1);

          LODOP.ADD_PRINT_TEXT(175, 14, 20, 48, "收件人");
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          LODOP.ADD_PRINT_TEXT(153, 35, 40, 20, "姓名:");
          LODOP.ADD_PRINT_TEXT(153, 75, 200, 20, objJson.ConsigneeName);
          LODOP.ADD_PRINT_TEXT(150, 282, 96, 20, "签收/代收件签:");
          LODOP.ADD_PRINT_TEXT(171, 35, 40, 20, "电话:");
          LODOP.ADD_PRINT_TEXT(171, 75, 200, 20, objJson.ConsigneePhone);
          LODOP.ADD_PRINT_TEXT(191, 35, 40, 20, "地址:");
          LODOP.ADD_PRINT_TEXT(191, 75, 203, 58, objJson.ConsigneeAddress);
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
          LODOP.ADD_PRINT_TEXT(235, 286, 96, 20, "    年  月  日");
          LODOP.ADD_PRINT_LINE(249, -1, 249, 1005, 0, 1);
          LODOP.ADD_PRINT_LINE(249, 280, 145, 280, 0, 1);

          LODOP.ADD_PRINT_TEXT(256, 14, 20, 48, "寄件人");
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          LODOP.ADD_PRINT_TEXT(256, 35, 40, 20, "姓名:");
          LODOP.ADD_PRINT_TEXT(256, 75, 124, 20, objJson.SendName);
          LODOP.ADD_PRINT_TEXT(256, 240, 40, 20, "电话:");
          LODOP.ADD_PRINT_TEXT(256, 280, 100, 20, objJson.SendPhone);
          LODOP.ADD_PRINT_TEXT(275, 35, 40, 20, "地址:");
          LODOP.ADD_PRINT_TEXT(275, 75, 284, 20, objJson.ShippingAddress);
          LODOP.ADD_PRINT_TEXT(294, 35, 64, 20, "寄件日期:");
          LODOP.ADD_PRINT_TEXT(294, 99, 107, 20, objJson.ExtSendDate);
          LODOP.ADD_PRINT_LINE(311, -1, 311, 1005, 0, 1);

          LODOP.ADD_PRINT_TEXT(320, 14, 20, 58, "内件品名");
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          LODOP.ADD_PRINT_TEXT(315, 35, 345, 78, objJson.ListInfo);
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
          if (objJson.ProCount != null && objJson.ProCount != "") {
            LODOP.ADD_PRINT_TEXT(375, 323, 40, 20, objJson.ProCount);
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
            LODOP.ADD_PRINT_TEXT(377, 308, 63, 20, "共    件");
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
            LODOP.SET_PRINT_STYLEA(0, "Horient", 1);
          }
          LODOP.ADD_PRINT_LINE(390, -1, 390, 1005, 0, 1);

          if (objJson.ExtCustomCode != null && objJson.ExtCustomCode != "") {
            LODOP.ADD_PRINT_TEXT(395, 14, 30, 20, "LC:");
            LODOP.ADD_PRINT_TEXT(395, 40, 150, 20, objJson.ExtCustomCode);
          }
          if (objJson.ServCodAmount != null && objJson.ServCodAmount != "") {
            LODOP.ADD_PRINT_TEXT(395, 196, 63, 20, "代收金额:");
            LODOP.ADD_PRINT_TEXT(391, 256, 150, 20, objJson.ServCodAmount);
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
          }


          LODOP.ADD_PRINT_IMAGE(418, 5, "40mm", "17.99mm", "URL:" + objJson.CpLogoDown);
          LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);
          LODOP.ADD_PRINT_BARCODE(426, 150, "59mm", "15mm", objJson.CodecType, objJson.WaybillCode);
          LODOP.ADD_PRINT_LINE(484, -1, 484, 1005, 0, 1);
          LODOP.ADD_PRINT_LINE(484, 32, 607, 32, 0, 1);
          LODOP.ADD_PRINT_TEXT(486, 35, 40, 20, "姓名:");
          LODOP.ADD_PRINT_TEXT(486, 75, 100, 20, objJson.ConsigneeName);
          LODOP.ADD_PRINT_TEXT(486, 188, 40, 20, "电话:");
          LODOP.ADD_PRINT_TEXT(486, 228, 150, 20, objJson.ConsigneePhone);
          LODOP.ADD_PRINT_TEXT(493, 14, 20, 48, "收件人");
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          LODOP.ADD_PRINT_TEXT(506, 35, 40, 20, "地址:");
          LODOP.ADD_PRINT_TEXT(506, 75, 303, 45, objJson.ConsigneeAddress);
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
          LODOP.ADD_PRINT_LINE(549, -1, 549, 1005, 0, 1);
          LODOP.ADD_PRINT_TEXT(552, 14, 20, 48, "寄件人");
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          LODOP.ADD_PRINT_TEXT(553, 35, 39, 25, "姓名:");
          LODOP.ADD_PRINT_TEXT(553, 75, 100, 20, objJson.SendName);
          LODOP.ADD_PRINT_TEXT(553, 242, 39, 20, "电话:");
          LODOP.ADD_PRINT_TEXT(553, 281, 97, 20, objJson.SendPhone);
          LODOP.ADD_PRINT_TEXT(570, 35, 39, 20, "地址:");
          LODOP.ADD_PRINT_TEXT(570, 75, 300, 20, objJson.ShippingAddress);
          LODOP.ADD_PRINT_TEXT(588, 35, 64, 20, "寄件日期:");
          LODOP.ADD_PRINT_TEXT(588, 99, 282, 20, objJson.ExtSendDate);
          LODOP.ADD_PRINT_LINE(607, -1, 607, 1005, 0, 1);
          LODOP.ADD_PRINT_TEXT(648, 4, 27, 20, "No:");
          LODOP.ADD_PRINT_TEXT(648, 26, 108, 20, "【云】" + objJson.OrderCode);
          if (objJson.Delivery != null && objJson.Delivery != "") {
            LODOP.ADD_PRINT_TEXT(648, 135, 118, 20, objJson.Delivery);
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          }
          if (objJson.Shelves != null && objJson.Shelves != "") {
            LODOP.ADD_PRINT_TEXT(648, 254, 70, 20, objJson.Shelves);
          }
          LODOP.ADD_PRINT_TEXT(647, 325, 70, 20, "已验视");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
        }
          break;
      }

      if (this.findMachine || (!this.findMachine && this.getPrinter(objJson, 1))) {
        switch (that.a.EBill.printType) {
          case 1: /*预览*/
            LODOP.PREVIEW();
            break;
          case 2: /*打印*/
            // LODOP.PRINT();

            // 打印并获取打印任务号
            var printTaskId = LODOP.PRINT();
            // 监听打印完成状态
            LODOP.On_Return=function(TaskID, Value){//TaskID:任务id，Value：job代码
              if (TaskID === printTaskId) {
                // 打印完成
                if(Value){
                  alert("打印成功");
                }else {
                  alert("打印失败");
                }
              }
            };
            break;
        }
      }
    },
    YtoPrint: function (LODOP, objJson) {
      let isCod = objJson.ServCodAmount && objJson.ServCodAmount != ""; /*是否代收货款件*/

      switch (objJson.TemplateType) {
        case 1:
        {
          LODOP.PRINT_INITA("0mm", "0mm", "76mm", "130mm","圆通一联单" + (objJson.OrderId == null || objJson.OrderId == "" ? "" : " - " + objJson.OrderId));
          LODOP.SET_PRINT_PAGESIZE(0, "76mm", "130mm", "");

          /*线条布局*/
          LODOP.ADD_PRINT_LINE("21.99mm", "1.01mm", "21.99mm", "75.12mm", 0, 1);
          LODOP.ADD_PRINT_LINE("59.8mm", "48.9mm", "35.69mm", "48.9mm", 0, 1);
          LODOP.ADD_PRINT_LINE("43.89mm", "48.95mm", "43.89mm", "75.46mm", 0, 1);
          LODOP.ADD_PRINT_LINE("90.2mm", "1.01mm", "90.2mm", "75.12mm", 0, 1);
          LODOP.ADD_PRINT_LINE("70.59mm", "1.01mm", "70.59mm", "75.12mm", 0, 1);
          LODOP.ADD_PRINT_LINE("60.3mm", "0.5mm", "60.3mm", "74.61mm", 0, 1);
          LODOP.ADD_PRINT_LINE("14.29mm", "1.01mm", "14.29mm", "75.12mm", 0, 1);
          LODOP.ADD_PRINT_LINE("81.23mm", "1.01mm", "81.23mm", "75.12mm", 0, 1);
          LODOP.ADD_PRINT_LINE("35.69mm", "1.01mm", "35.69mm", "75.12mm", 0, 1);
          LODOP.ADD_PRINT_LINE("70.38mm", "6.11mm", "35.69mm", "6.11mm", 0, 1);
          LODOP.ADD_PRINT_LINE("110.91mm", "6.11mm", "90.8mm", "6.11mm", 0, 1);
          LODOP.ADD_PRINT_LINE("80.14mm", "27.31mm", "70.86mm", "27.31mm", 0, 1);
          LODOP.ADD_PRINT_LINE("111.71mm", "1.01mm", "111.71mm", "75.12mm", 0, 1);

          /*COD代收货款信息*/
          if (isCod) {
            LODOP.ADD_PRINT_TEXT("1.76mm", "2.12mm", "29.37mm", "6.61mm", "代收货款");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-0.26mm");
            LODOP.ADD_PRINT_TEXT("6.09mm", "2.12mm", "29.37mm", "4.76mm", "金额：");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-0.26mm");
            LODOP.ADD_PRINT_TEXT("6.09mm", "11.91mm", "29.37mm", "4.76mm", objJson.ServCodAmount);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-0.26mm");
            LODOP.ADD_PRINT_TEXT("9.79mm", "2.12mm", "29.37mm", "4.76mm", objJson.ExtCustomCode);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-0.26mm");
          } else {
            LODOP.ADD_PRINT_IMAGE("1.01mm", "1.01mm", "25.4mm", "12.96mm", "URL:https://img.yunchepin.cn/express_logo/YTO.png?v=1");
            LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);
          }

          /*目的地代码*/
          if (objJson.PackageCenterCode != null && objJson.PackageCenterCode != '') {
            LODOP.ADD_PRINT_BARCODE("2.91mm", "47.36mm", "26.7mm", "10mm", objJson.CodecType, objJson.PackageCenterCode);
          }

          /*大头笔*/
          if (objJson.ShortAddress != null && objJson.ShortAddress != '') {
            LODOP.ADD_PRINT_TEXT("13.92mm", "1.59mm", "73.03mm", "7.94mm", objJson.ShortAddress);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 24);
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-0.53mm");
          }

          /*物流编号*/
          LODOP.ADD_PRINT_BARCODE("22.49mm", "5.29mm", "63.5mm", "12.49mm", objJson.CodecType, objJson.WaybillCode);
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);

          /*收件*/
          LODOP.ADD_PRINT_TEXT("43.39mm", "1.59mm", "5.82mm", "9.26mm", "收件");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.ADD_PRINT_TEXT("36.51mm", "7.67mm", "18.79mm", "5.29mm", objJson.ConsigneeName);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "Horient", 3);
          LODOP.ADD_PRINT_TEXT("36.51mm", "26.19mm", "23.02mm", "5.29mm", objJson.ConsigneePhone);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.ADD_PRINT_TEXT("42.07mm", "7.41mm", "41.59mm", "13.76mm", objJson.ConsigneeAddress);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-0.79mm");

          /*寄件日期*/
          LODOP.ADD_PRINT_TEXT("56.62mm", "12.7mm", "16.14mm", "5.03mm", "打印时间：");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.ADD_PRINT_TEXT("56.62mm", "25.4mm", "24.34mm", "5.03mm", objJson.ExtSendDate);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);

          /*寄件*/
          LODOP.ADD_PRINT_TEXT("61.38mm", "1.59mm", "5.82mm", "10.58mm", "寄件");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.ADD_PRINT_TEXT("60.85mm", "7.41mm", "42.07mm", "5.03mm", objJson.SendName + " " + objJson.SendPhone);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
          LODOP.ADD_PRINT_TEXT("64.82mm", "7.41mm", "68.79mm", "5.03mm", objJson.ShippingAddress);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-0.79mm");
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);

          /*服务*/
          LODOP.ADD_PRINT_TEXT("36.51mm", "53.98mm", "14.29mm", "7.67mm", "服务");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);

          /*付款方式*/
          LODOP.ADD_PRINT_TEXT("46.3mm", "49.74mm", "12.01mm", "5.29mm", "付款：");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-0.53mm");
          LODOP.ADD_PRINT_TEXT("46.3mm", "58.21mm", "19.31mm", "5.29mm", "寄付月结");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-0.53mm");
          /*实际重量*/
          LODOP.ADD_PRINT_TEXT("50.27mm", "49.48mm", "12.01mm", "5.29mm", "重量：");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-0.53mm");

          /*圆通Logo*/
          LODOP.ADD_PRINT_IMAGE("70.91mm", "1.59mm", "21.96mm", "10.32mm", "URL:https://img.yunchepin.cn/express_logo/YTO.png?v=1");
          LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);

          /*物流编号*/
          LODOP.ADD_PRINT_BARCODE("71.57mm", "30.96mm", "42.36mm", "8.68mm", objJson.CodecType, objJson.WaybillCode);
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);

          /*商品清单*/
          LODOP.ADD_PRINT_TEXT("92.6mm", "1.59mm", "5.29mm", "16.4mm", "内件品名");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.ADD_PRINT_TEXT("90.75mm", "6.88mm", "69.32mm", "20.64mm", objJson.ListInfo);
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-0.79mm");
          if (objJson.ProCount != null && objJson.ProCount != "") {
            LODOP.ADD_PRINT_TEXT("107.61mm", "56.89mm", "7.14mm", "5.29mm", "共");
            LODOP.ADD_PRINT_TEXT("107.61mm", "60.33mm", "7.67mm", "5.29mm", objJson.ProCount);
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
            LODOP.ADD_PRINT_TEXT("107.61mm", "67.47mm", "7.14mm", "5.29mm", "件");
          }

          if (objJson.OrderCode != null && objJson.OrderCode != "") {
            LODOP.ADD_PRINT_TEXT("107.61mm", "7.41mm", "7.94mm", "5.29mm", "No:");
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.ADD_PRINT_TEXT("107.61mm", "13.76mm", "31.99mm", "5.29mm", "【云】" + objJson.OrderCode);
          }
          if (objJson.Delivery != null && objJson.Delivery != "") {
            LODOP.ADD_PRINT_TEXT("111.92mm", "4.23mm", "31.75mm", "5.29mm", objJson.Delivery);
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          }
          if (objJson.Shelves != null && objJson.Shelves != "") {
            LODOP.ADD_PRINT_TEXT("112.18mm", "38.36mm", "23.81mm", "5.29mm", objJson.Shelves);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          }
          LODOP.ADD_PRINT_TEXT("111.92mm", "59.27mm", "15.35mm", "5.29mm", "已验视");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
        }
          break;
        case 2:
        default:
        {
          LODOP.PRINT_INITA(0, 0, "100mm", "180mm", "圆通标准面单" + (objJson.OrderId == null || objJson.OrderId == "" ? "" : " - " + objJson.OrderId));
          LODOP.SET_PRINT_PAGESIZE(0, "100mm", "180mm", "");

          /*线条布局*/
          LODOP.ADD_PRINT_LINE("38.36mm", 4, 144, 374, 0, 1);
          LODOP.ADD_PRINT_LINE(360, 260, 221, 261, 0, 1);
          LODOP.ADD_PRINT_LINE(257, 260, 256, 376, 0, 1);
          LODOP.ADD_PRINT_LINE(565, 4, 564, 374, 0, 1);
          LODOP.ADD_PRINT_LINE(524, 4, 523, 283, 0, 1);
          LODOP.ADD_PRINT_LINE(473, 4, 472, 374, 0, 1);
          LODOP.ADD_PRINT_LINE(361, 4, 360, 374, 0, 1);
          LODOP.ADD_PRINT_LINE("16.67mm", 4, 62, 374, 0, 1);
          LODOP.ADD_PRINT_LINE(302, 4, 301, 260, 0, 1);
          LODOP.ADD_PRINT_LINE(222, 0, 221, 378, 0, 1);
          LODOP.ADD_PRINT_LINE(360, 26, 221, 27, 0, 1);
          LODOP.ADD_PRINT_LINE(416, 0, 416, 378, 0, 1);
          LODOP.ADD_PRINT_LINE(640, 26, 472, 27, 0, 1);
          LODOP.ADD_PRINT_LINE(472, 283, 564, 284, 0, 1);
          LODOP.ADD_PRINT_LINE(416, 150, 360, 151, 0, 1);
          LODOP.ADD_PRINT_LINE(416, 260, 360, 261, 0, 1);
          LODOP.ADD_PRINT_LINE(642, 4, 641, 374, 0, 1);

          /*COD代收货款信息*/
          if (isCod) {
            LODOP.ADD_PRINT_TEXT(7, 8, 111, 25, "代收货款");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 15);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
            LODOP.ADD_PRINT_TEXT(30, 8, 111, 18, "金额：");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
            LODOP.ADD_PRINT_TEXT(30, 45, 111, 18, objJson.ServCodAmount);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "宋体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
            LODOP.ADD_PRINT_TEXT(45, 8, 111, 18, objJson.ExtCustomCode);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "宋体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", 0);
          } else {
            LODOP.ADD_PRINT_IMAGE(7, 8, 116, 50, "URL:https://img.yunchepin.cn/express_logo/YTO.png?v=1");
            LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);
          }

          /*目的地代码*/
          if (objJson.PackageCenterCode != null && objJson.PackageCenterCode != '') {
            LODOP.ADD_PRINT_BARCODE(15, 248, "31.99mm", "10mm", objJson.CodecType, objJson.PackageCenterCode);
          }

          /*大头笔*/
          if (objJson.ShortAddress != null && objJson.ShortAddress != '') {
            LODOP.ADD_PRINT_TEXT("20mm", 6, 365, 55, objJson.ShortAddress);/*例："021x-300-096"*/
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 36);
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
          }

          /*物流编号*/
          LODOP.ADD_PRINT_BARCODE(151, "45pt", 265, "51pt", objJson.CodecType, objJson.WaybillCode);

          /*收件*/
          LODOP.ADD_PRINT_TEXT(251, 7, 22, 40, "收件");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          LODOP.ADD_PRINT_TEXT(225, 33, 71, 19, objJson.ConsigneeName);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          LODOP.ADD_PRINT_TEXT(225, 103, 192, 19, objJson.ConsigneePhone);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          LODOP.ADD_PRINT_TEXT(241, 33, 227, 52, objJson.ConsigneeAddress);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);

          /*寄件日期*/
          LODOP.ADD_PRINT_TEXT(289, 121, 61, 19, "打印时间：");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.ADD_PRINT_TEXT(289, 169, 92, 19, objJson.ExtSendDate);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);

          /*寄件*/
          LODOP.ADD_PRINT_TEXT(317, 7, 22, 40, "寄件");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          LODOP.ADD_PRINT_TEXT(305, 32, 227, 30, objJson.ShippingAddress);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.ADD_PRINT_TEXT(344, 32, 240, 19, objJson.SendName + " " + objJson.SendPhone);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);

          /*服务*/
          LODOP.ADD_PRINT_TEXT(229, 290, 54, 29, "服务");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);

          /*实际重量*/
          /*
          LODOP.ADD_PRINT_TEXT(261, 266, 73, 20, "实际重量：");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
          */
          /*付款方式*/
          LODOP.ADD_PRINT_TEXT(261, 266, 73, 20, "付款方式：");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
          LODOP.ADD_PRINT_TEXT(261, 316, 73, 20, "寄付月结");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
          /*实际重量*/
          LODOP.ADD_PRINT_TEXT(276, 266, 73, 20, "实际重量：");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);

          /*签收栏*/
          LODOP.ADD_PRINT_TEXT(364, 8, 158, 53, "您的签字代表您已验收此包裹，并确认商品完好无损，没有划痕，没有损坏等质量问题。");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
          LODOP.ADD_PRINT_TEXT(368, 154, 50, 20, "签收人：");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
          LODOP.ADD_PRINT_TEXT(388, 154, 50, 20, "时间：");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
          LODOP.ADD_PRINT_TEXT(365, 268, 50, 20, "收件员：");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
          LODOP.ADD_PRINT_TEXT(381, 268, 60, 20, "寄件日期：");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
          LODOP.ADD_PRINT_TEXT(397, 268, 50, 20, "派件员：");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);

          /*快递公司logo*/
          LODOP.ADD_PRINT_IMAGE(422, 6, 116, 50, "URL:https://img.yunchepin.cn/express_logo/YTO.png?v=1");
          LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);
          LODOP.ADD_PRINT_BARCODE(431, 130, "45.01mm", "10mm", objJson.CodecType, objJson.WaybillCode);

          /*收件*/
          LODOP.ADD_PRINT_TEXT(482, 7, 22, 30, "收件");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          LODOP.ADD_PRINT_TEXT(475, 32, 71, 19, objJson.ConsigneeName);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
          LODOP.ADD_PRINT_TEXT(475, 102, 179, 19, objJson.ConsigneePhone);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
          LODOP.ADD_PRINT_TEXT(487, 32, 253, 37, objJson.ConsigneeAddress);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);

          /*寄件*/
          LODOP.ADD_PRINT_TEXT(530, 7, 22, 30, "寄件");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          LODOP.ADD_PRINT_TEXT(550, 32, 240, 19, objJson.SendName + ' ' + objJson.SendPhone);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
          LODOP.ADD_PRINT_TEXT(527, 32, 252, 30, objJson.ShippingAddress);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);

          /*COD代收货款信息*/
          if (isCod) {
            if (objJson.ServCodAmount != null && objJson.ServCodAmount != "") {
              LODOP.ADD_PRINT_TEXT(479, 286, 111, 25, "代收货款");
              LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
              LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
              LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
              LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
              LODOP.ADD_PRINT_TEXT(502, 286, 111, 18, objJson.ServCodAmount);
              LODOP.SET_PRINT_STYLEA(0, "FontName", "宋体");
              LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
              LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
              LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
            }
            if (objJson.ExtCustomCode != null && objJson.ExtCustomCode != "") {
              LODOP.ADD_PRINT_TEXT(517, 286, 111, 18, objJson.ExtCustomCode);
              LODOP.SET_PRINT_STYLEA(0, "FontName", "宋体");
              LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
              LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
            }
          }

          /*商品清单*/
          LODOP.ADD_PRINT_TEXT(571, 7, 20, 72, "内件品名");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.ADD_PRINT_TEXT(567, 32, 345, 78, objJson.ListInfo);
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
          if (objJson.ProCount != null && objJson.ProCount != "") {
            LODOP.ADD_PRINT_TEXT(626, 308, 63, 20, "共    件");
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
            LODOP.SET_PRINT_STYLEA(0, "Horient", 1);
            LODOP.ADD_PRINT_TEXT(624, 323, 40, 20, objJson.ProCount);
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
          }

          if (objJson.OrderCode != null && objJson.OrderCode != "") {
            LODOP.ADD_PRINT_TEXT(648, 4, 27, 20, "No:");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
            LODOP.ADD_PRINT_TEXT(648, 26, 108, 20, "【云】" + objJson.OrderCode);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          }
          if (objJson.Delivery != null && objJson.Delivery != "") {
            LODOP.ADD_PRINT_TEXT(648, 135, 118, 20, objJson.Delivery);
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          }
          if (objJson.Shelves != null && objJson.Shelves != "") {
            LODOP.ADD_PRINT_TEXT(648, 254, 70, 20, objJson.Shelves);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          }
          LODOP.ADD_PRINT_TEXT(647, 325, 70, 20, "已验视");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
        }
          break;
      }

      if (this.findMachine || (!this.findMachine && this.getPrinter(objJson))) {
        switch (that.a.EBill.printType) {
          case 1: /*预览*/
            LODOP.PREVIEW();
            break;
          case 2: /*打印*/
            // LODOP.PRINT();

            // 打印并获取打印任务号
            var printTaskId = LODOP.PRINT();
            // 监听打印完成状态
            LODOP.On_Return=function(TaskID, Value){//TaskID:任务id，Value：job代码
              if (TaskID === printTaskId) {
                // 打印完成
                if(Value){
                  alert("打印成功");
                }else {
                  alert("打印失败");
                }
              }
            };
            break;
        }
      }
    },
    ShunFengPrint: function (LODOP, objJson) {
      switch (objJson.TemplateType) {
        case 1:
        {
          LODOP.PRINT_INITA(0, 0, "76mm", "130mm", "顺丰一联单" + (objJson.OrderId == null || objJson.OrderId == "" ? "" : " - " + objJson.OrderId));
          LODOP.SET_PRINT_PAGESIZE(0, "76mm", "130mm", "");

          /*线条布局*/
          LODOP.ADD_PRINT_LINE("57.18mm", "2.99mm", "57.18mm", "73.08mm", 0, 1);
          LODOP.ADD_PRINT_LINE("93.72mm", "47.36mm", "44.5mm", "47.36mm", 0, 1);
          LODOP.ADD_PRINT_LINE("66.36mm", "47.1mm", "66.36mm", "73mm", 0, 1);
          LODOP.ADD_PRINT_LINE("108.45mm", "2.99mm", "108.45mm", "73.08mm", 0, 1);
          LODOP.ADD_PRINT_LINE("93.95mm", "2.99mm", "93.95mm", "73.08mm", 0, 1);
          LODOP.ADD_PRINT_LINE("14.87mm", "2.99mm", "14.87mm", "73.08mm", 0, 1);
          LODOP.ADD_PRINT_LINE("44.77mm", "2.99mm", "44.77mm", "73.08mm", 0, 1);
          LODOP.ADD_PRINT_LINE("78.37mm", "2.99mm", "78.37mm", "46.09mm", 0, 1);
          LODOP.ADD_PRINT_LINE("34.95mm", "2.99mm", "34.95mm", "73.08mm", 0, 1);
          LODOP.ADD_PRINT_LINE("93.72mm", "5.29mm", "56.91mm", "5.29mm", 0, 1);
          LODOP.ADD_PRINT_LINE("108.48mm", "24.08mm", "93.69mm", "24.08mm", 0, 1);
          LODOP.ADD_PRINT_LINE("121.97mm", "2.99mm", "121.97mm", "73.08mm", 0, 1);

          /*快递公司logo*/
          LODOP.ADD_PRINT_IMAGE("1.06mm", "1.59mm", "24.87mm", "10.58mm", "URL:https://img.yunchepin.cn/express_logo/shunfeng.png");
          LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);

          /*物流单号*/
          LODOP.ADD_PRINT_BARCODE("17.2mm", "3.7mm", "70.11mm", "15.35mm", objJson.CodecType, objJson.WaybillCode);

          /*是否COD,代收金额值清零*/
          if (objJson.ServCodAmount != null && objJson.ServCodAmount != "") {
            LODOP.ADD_PRINT_TEXT("0.79mm", "46.3mm", "25.14mm", "11.38mm", "COD");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 30);
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 3);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          }

          /*原寄地*/
          if (objJson.ShippingBranchCode != null && objJson.ShippingBranchCode != "") {
            LODOP.ADD_PRINT_TEXT("38.1mm", "2.38mm", "19.31mm", "6.09mm", "原寄地：");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-0.53mm");
            LODOP.ADD_PRINT_TEXT("37.84mm", "14.02mm", "21.96mm", "6.09mm", objJson.ShippingBranchCode.length > 10 ? objJson.ShippingBranchCode.substring(0, 10) : objJson.ShippingBranchCode);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
          }
          if (objJson.PackageCenterCode != null && objJson.PackageCenterCode != "") {
            /*目的地*/
            LODOP.ADD_PRINT_TEXT("38.1mm", "34.4mm", "20.9mm", "6.09mm", "目的地：");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-0.26mm");
            LODOP.ADD_PRINT_TEXT("37.57mm", "47.63mm", "28.05mm", "6.35mm", objJson.PackageCenterCode.length > 10 ? objJson.PackageCenterCode.substring(0, 10) : objJson.PackageCenterCode);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "Arial");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          }

          /*业务类型*/
          LODOP.ADD_PRINT_TEXT("47.89mm", "2.91mm", "23.81mm", "7.14mm", "业务类型：");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-0.53mm");
          LODOP.ADD_PRINT_TEXT("47.63mm", "21.7mm", "23.81mm", "7.67mm", "标准快递");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 13);
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-0.53mm");
          /*代收金额：*/
          if (objJson.ServCodAmount != null && objJson.ServCodAmount != "") {
            LODOP.ADD_PRINT_TEXT("45.51mm", "51.86mm", "16.14mm", "4.76mm", "代收货款");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-0.26mm");
            LODOP.ADD_PRINT_TEXT("49.48mm", "47.89mm", "28.05mm", "4.76mm", "￥" + objJson.ServCodAmount);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-0.26mm");
          }
          /*月结LC号：*/
          if (objJson.ExtCustomCode != null && objJson.ExtCustomCode != "") {
            LODOP.ADD_PRINT_TEXT("53.45mm", "47.89mm", "28.05mm", "4.76mm", objJson.ExtCustomCode);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-0.26mm");
          }

          /*收件*/
          LODOP.ADD_PRINT_TEXT("64.82mm", "1.85mm", "5.82mm", "10.58mm", "收件");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.ADD_PRINT_TEXT("62.44mm", "6.09mm", "40.75mm", "13.76mm", objJson.ConsigneeAddress);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-0.79mm");
          LODOP.ADD_PRINT_TEXT("58.21mm", "6.09mm", "41.54mm", "5.03mm", objJson.ConsigneeName);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.ADD_PRINT_TEXT("58.21mm", "24.61mm", "45.77mm", "5.03mm", objJson.ConsigneePhone);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");

          /*寄件日期*/
          LODOP.ADD_PRINT_TEXT("74.88mm", "10.32mm", "16.14mm", "5.03mm", "打印时间：");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.ADD_PRINT_TEXT("74.88mm", "23.02mm", "24.34mm", "5.03mm", objJson.ExtSendDate);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);

          /*寄件*/
          LODOP.ADD_PRINT_TEXT("82.29mm", "1.85mm", "5.82mm", "10.58mm", "寄件");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.ADD_PRINT_TEXT("79.11mm", "6.09mm", "41.01mm", "10.58mm", objJson.ShippingAddress);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-0.79mm");
          LODOP.ADD_PRINT_TEXT("90.22mm", "6.09mm", "17.46mm", "5.03mm", objJson.SendName);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.ADD_PRINT_TEXT("90.22mm", "21.7mm", "25.4mm", "5.03mm", objJson.SendPhone);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");

          /*服务*/
          LODOP.ADD_PRINT_TEXT("57.94mm", "53.18mm", "14.29mm", "7.67mm", "服务");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);

          if (objJson.CustID != null && objJson.CustID != "") {
            /*付款方式*/
            LODOP.ADD_PRINT_TEXT("67.47mm", "47.63mm", "12.7mm", "5.29mm", "付款：");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-0.53mm");
            LODOP.ADD_PRINT_TEXT("67.47mm", "55.03mm", "19.31mm", "5.29mm", "寄付月结");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-0.53mm");
            /*月结账号*/
            LODOP.ADD_PRINT_TEXT("71.44mm", "47.63mm", "12.7mm", "5.29mm", "月结：");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-0.53mm");
            LODOP.ADD_PRINT_TEXT("71.44mm", "55.03mm", "19.31mm", "5.29mm", objJson.CustID);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-0.26mm");
            /*实际重量*/
            LODOP.ADD_PRINT_TEXT("75.14mm", "47.63mm", "12.7mm", "5.29mm", "重量：");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-0.53mm");
          } else {
            /*付款方式*/
            LODOP.ADD_PRINT_TEXT("67.47mm", "47.63mm", "12.7mm", "5.29mm", "付款：");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-0.53mm");
            LODOP.ADD_PRINT_TEXT("67.47mm", "55.03mm", "19.31mm", "5.29mm", "到付");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-0.53mm");
            /*实际重量*/
            LODOP.ADD_PRINT_TEXT("71.44mm", "47.63mm", "12.7mm", "5.29mm", "重量：");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-0.53mm");
          }

          /*物流编号*/
          LODOP.ADD_PRINT_BARCODE("96.31mm", "26.99mm", "45.01mm", "10mm", objJson.CodecType, objJson.WaybillCode);

          /*商品清单*/
          LODOP.ADD_PRINT_TEXT("108.74mm", "2.91mm", "70.11mm", "12.96mm", objJson.ListInfo);
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
          LODOP.ADD_PRINT_TEXT("118.27mm", "6.09mm", "8.47mm", "5.29mm", "No:");
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          LODOP.ADD_PRINT_TEXT("118.27mm", "12.17mm", "28.58mm", "5.29mm", "【云】" + objJson.OrderCode);
          if (objJson.ProCount != null && objJson.ProCount != "") {
            LODOP.ADD_PRINT_TEXT("118.27mm", "56.62mm", "5.82mm", "5.29mm", "共");
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
            LODOP.ADD_PRINT_TEXT("117.48mm", "59.8mm", "7.67mm", "5.29mm", objJson.ProCount);
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-0.26mm");
            LODOP.ADD_PRINT_TEXT("118.27mm", "66.94mm", "5.29mm", "5.29mm", "件");
          }
          if (objJson.Delivery != null && objJson.Delivery != "") {
            LODOP.ADD_PRINT_TEXT("122.5mm", "5.29mm", "31.75mm", "5.29mm", objJson.Delivery);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          }
          if (objJson.Shelves != null && objJson.Shelves != "") {
            LODOP.ADD_PRINT_TEXT("122.77mm", "41.28mm", "18.52mm", "5.29mm", objJson.Shelves);
          }
          LODOP.ADD_PRINT_TEXT("122.5mm", "60.59mm", "13.49mm", "5.82mm", "已验视");
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
        }
          break;
        case 2:
        default:
        {
          LODOP.PRINT_INITA(0, 0, "100mm", "180mm", "顺丰标准面单" + (objJson.OrderId == null || objJson.OrderId == "" ? "" : " - " + objJson.OrderId));
          LODOP.SET_PRINT_PAGESIZE(0, "100mm", "180mm", "");

          /*线条布局*/
          LODOP.ADD_PRINT_LINE(143, 4, 142, 374, 0, 1);
          LODOP.ADD_PRINT_LINE(281, 260, 95, 261, 0, 1);
          LODOP.ADD_PRINT_LINE(178, 260, 177, 376, 0, 1);
          LODOP.ADD_PRINT_LINE(565, 4, 564, 374, 0, 1);
          LODOP.ADD_PRINT_LINE(524, 4, 523, 283, 0, 1);
          LODOP.ADD_PRINT_LINE(473, 4, 472, 374, 0, 1);
          LODOP.ADD_PRINT_LINE(361, 4, 360, 374, 0, 1);
          LODOP.ADD_PRINT_LINE(56, 4, 55, 374, 0, 1);
          LODOP.ADD_PRINT_LINE(96, 4, 95, 374, 0, 1);
          LODOP.ADD_PRINT_LINE(223, 4, 222, 260, 0, 1);
          LODOP.ADD_PRINT_LINE(282, 0, 281, 378, 0, 1);
          LODOP.ADD_PRINT_LINE(281, 26, 142, 27, 0, 1);
          LODOP.ADD_PRINT_LINE("110mm", 0, 416, "100mm", 0, 1);
          LODOP.SET_PRINT_STYLEA(0, "PreviewOnly", 1);
          LODOP.ADD_PRINT_LINE(640, 26, 472, 27, 0, 1);
          LODOP.ADD_PRINT_LINE(472, 283, 564, 284, 0, 1);
          LODOP.ADD_PRINT_LINE(416, 150, 360, 151, 0, 1);
          LODOP.ADD_PRINT_LINE(416, 265, 360, 266, 0, 1);
          LODOP.ADD_PRINT_LINE(642, 4, 641, 374, 0, 1);

          /*快递公司logo*/
          LODOP.ADD_PRINT_IMAGE(4, 6, 96, 50, "URL:https://img.yunchepin.cn/express_logo/ShunFeng.png");
          LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);
          /*是否COD,代收金额值清零*/
          if (objJson.ServCodAmount != null && objJson.ServCodAmount != "") {
            LODOP.ADD_PRINT_TEXT(2, 275, 95, 48, "COD");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 36);
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 3);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          }

          /*原寄地*/
          if (objJson.ShippingBranchCode != null && objJson.ShippingBranchCode != "") {
            LODOP.ADD_PRINT_TEXT(67, 7, 73, 23, "原寄地：");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
            LODOP.ADD_PRINT_TEXT(67, 60, 93, 23, objJson.ShippingBranchCode.length > 10 ? objJson.ShippingBranchCode.substring(0, 10) : objJson.ShippingBranchCode);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
          }
          if (objJson.PackageCenterCode != null && objJson.PackageCenterCode != "") {
            /*目的地*/
            LODOP.ADD_PRINT_TEXT(67, 158, 79, 23, "目的地：");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
            LODOP.ADD_PRINT_TEXT(64, 216, 161, 29, objJson.PackageCenterCode.length > 10 ? objJson.PackageCenterCode.substring(0, 10) : objJson.PackageCenterCode);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "Arial");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 16);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          }

          /*业务类型*/
          LODOP.ADD_PRINT_TEXT(107, 6, 111, 33, "业务类型：");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
          LODOP.ADD_PRINT_TEXT(107, 89, 111, 33, "标准快递");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
          /*代收金额：*/
          if (objJson.ServCodAmount != null && objJson.ServCodAmount != "") {
            LODOP.ADD_PRINT_TEXT(100, 267, 111, 18, "代收货款金额");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
            LODOP.ADD_PRINT_TEXT(114, 267, 111, 18, "￥" + objJson.ServCodAmount);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
          }
          /*月结LC号：*/
          if (objJson.ExtCustomCode != null && objJson.ExtCustomCode != "") {
            /*
            LODOP.ADD_PRINT_TEXT(128, 267, 45, 18, "卡号：");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
            LODOP.ADD_PRINT_TEXT(128, 295, 111, 18, objJson.ExtCustomCode);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
            */
            LODOP.ADD_PRINT_TEXT(128, 267, 156, 18, objJson.ExtCustomCode);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
          }

          /*收件*/
          LODOP.ADD_PRINT_TEXT(172, 7, 22, 40, "收件");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          LODOP.ADD_PRINT_TEXT(146, 33, 71, 19, objJson.ConsigneeName);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          LODOP.ADD_PRINT_TEXT(146, 103, 192, 19, objJson.ConsigneePhone);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          LODOP.ADD_PRINT_TEXT(162, 33, 227, 52, objJson.ConsigneeAddress);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
          /*寄件日期*/
          LODOP.ADD_PRINT_TEXT(210, 121, 61, 19, "打印时间：");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.ADD_PRINT_TEXT(210, 169, 92, 19, objJson.ExtSendDate);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          /*寄件*/
          LODOP.ADD_PRINT_TEXT(238, 7, 22, 40, "寄件");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          LODOP.ADD_PRINT_TEXT(226, 32, 227, 30, objJson.ShippingAddress);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
          LODOP.ADD_PRINT_TEXT(265, 32, 71, 19, objJson.SendName);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          LODOP.ADD_PRINT_TEXT(265, 102, 158, 19, objJson.SendPhone);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          /*服务*/
          LODOP.ADD_PRINT_TEXT(150, 290, 54, 29, "服务");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);

          if (objJson.CustID != null && objJson.CustID != "") {
            /*付款方式*/
            LODOP.ADD_PRINT_TEXT(182, 266, 73, 20, "付款方式：");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
            LODOP.ADD_PRINT_TEXT(182, 316, 73, 20, "寄付月结");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
            /*月结账号*/
            LODOP.ADD_PRINT_TEXT(197, 266, 73, 20, "月结账号：");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
            LODOP.ADD_PRINT_TEXT(197, 316, 73, 20, objJson.CustID);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
            /*实际重量*/
            LODOP.ADD_PRINT_TEXT(212, 266, 73, 20, "实际重量：");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
          } else {
            /*付款方式*/
            LODOP.ADD_PRINT_TEXT(182, 266, 73, 20, "付款方式：");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
            LODOP.ADD_PRINT_TEXT(182, 316, 73, 20, "到付");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
            /*实际重量*/
            LODOP.ADD_PRINT_TEXT(197, 266, 73, 20, "实际重量：");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
          }

          /*物流编号*/
          LODOP.ADD_PRINT_BARCODE(290, 60, 265, 68, objJson.CodecType, objJson.WaybillCode);

          /*签收栏*/
          LODOP.ADD_PRINT_TEXT(364, 8, 158, 53, "您的签字代表您已验收此包裹，并确认商品完好无损，没有划痕，没有损坏等质量问题。");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
          LODOP.ADD_PRINT_TEXT(368, 154, 50, 20, "签收人：");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
          LODOP.ADD_PRINT_TEXT(388, 154, 50, 20, "时间：");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
          /*快递员取件信息*/
          LODOP.ADD_PRINT_TEXT(365, 268, 50, 20, "收件员：");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
          LODOP.ADD_PRINT_TEXT(381, 268, 60, 20, "寄件日期：");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
          LODOP.ADD_PRINT_TEXT(397, 268, 50, 20, "派件员：");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);

          /*快递公司logo*/
          LODOP.ADD_PRINT_IMAGE(422, 6, 96, 50, "URL:https://img.yunchepin.cn/express_logo/ShunFeng.png");
          LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);
          /*物流编号*/
          LODOP.ADD_PRINT_BARCODE(431, 130, "45mm", "10mm", objJson.CodecType, objJson.WaybillCode);

          /*收件*/
          LODOP.ADD_PRINT_TEXT(482, 7, 22, 30, "收件");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          LODOP.ADD_PRINT_TEXT(475, 32, 71, 19, objJson.ConsigneeName);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.ADD_PRINT_TEXT(475, 102, 179, 19, objJson.ConsigneePhone);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.ADD_PRINT_TEXT(487, 32, 253, 37, objJson.ConsigneeAddress);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
          /*寄件*/
          LODOP.ADD_PRINT_TEXT(530, 7, 22, 30, "寄件");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          LODOP.ADD_PRINT_TEXT(550, 32, 71, 19, objJson.SendName);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.ADD_PRINT_TEXT(550, 102, 179, 19, objJson.SendPhone);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.ADD_PRINT_TEXT(527, 32, 252, 30, objJson.ShippingAddress);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);

          /*商品清单*/
          LODOP.ADD_PRINT_TEXT(571, 7, 20, 72, "内件品名");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.ADD_PRINT_TEXT(567, 32, 345, 78, objJson.ListInfo);
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
          if (objJson.ProCount != null && objJson.ProCount != "") {
            LODOP.ADD_PRINT_TEXT(624, 323, 40, 20, objJson.ProCount);
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
            LODOP.ADD_PRINT_TEXT(626, 308, 63, 20, "共    件");
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
            LODOP.SET_PRINT_STYLEA(0, "Horient", 1);
          }
          LODOP.ADD_PRINT_TEXT(648, 4, 27, 20, "No:");
          LODOP.ADD_PRINT_TEXT(648, 26, 108, 20, "【云】" + objJson.OrderCode);
          if (objJson.Delivery != null && objJson.Delivery != "") {
            LODOP.ADD_PRINT_TEXT(646, 135, 118, 20, objJson.Delivery);
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          }
          if (objJson.Shelves != null && objJson.Shelves != "") {
            LODOP.ADD_PRINT_TEXT(648, 254, 70, 20, objJson.Shelves);
          }
          LODOP.ADD_PRINT_TEXT(647, 325, 70, 20, "已验视");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
        }
          break;
      }

      if (this.findMachine || (!this.findMachine && this.getPrinter(objJson))) {
        switch (that.a.EBill.printType) {
          case 1: /*预览*/
            LODOP.PREVIEW();
            break;
          case 2: /*打印*/
            // LODOP.PRINT();

            // 打印并获取打印任务号
            var printTaskId = LODOP.PRINT();
            // 监听打印完成状态
            LODOP.On_Return=function(TaskID, Value){//TaskID:任务id，Value：job代码
              if (TaskID === printTaskId) {
                // 打印完成
                if(Value){
                  alert("打印成功");
                }else {
                  alert("打印失败");
                }
              }
            };
            break;
        }
      }
    },
    FengQiaoPrint: function (LODOP, objJson) {
      let isCod = objJson.ServCodAmount && objJson.ServCodAmount != ""; /*是否代收货款件*/
      let isFwsy = false; /*是否丰网速运*/
      let req = eval("(" + objJson.Request + ")");
      if (req && req.expressTypeId == 242) {
        isFwsy = true;
      }

      switch (objJson.TemplateType) {
        case 1:
        {
          LODOP.PRINT_INITA(0, 0, "76mm", "130mm", "顺丰一联单[新]" + (objJson.OrderId == null || objJson.OrderId == "" ? "" : " - " + objJson.OrderId));
          LODOP.SET_PRINT_PAGESIZE(0, "76mm", "130mm", "");

          /*线条布局*/
          LODOP.ADD_PRINT_LINE("14mm", "0mm", "14mm", "76mm", 0, 1);
          LODOP.ADD_PRINT_LINE("38mm", "0mm", "38mm", "76mm", 0, 1);
          LODOP.ADD_PRINT_LINE("48mm", "0mm", "48mm", "76mm", 0, 1);
          LODOP.ADD_PRINT_LINE("67mm", "0mm", "67mm", "60mm", 0, 1);
          LODOP.ADD_PRINT_LINE("75mm", "0mm", "75mm", "60mm", 0, 1);
          LODOP.ADD_PRINT_LINE("81mm", "0mm", "81mm", "32mm", 0, 1);
          LODOP.ADD_PRINT_LINE("93mm", "0mm", "93mm", "32mm", 0, 1);
          LODOP.ADD_PRINT_LINE("75mm", "32mm", "105mm", "32mm", 0, 1);
          LODOP.ADD_PRINT_LINE("105mm", "0mm", "105mm", "60mm", 0, 1);
          LODOP.ADD_PRINT_LINE("111mm", "0mm", "111mm", "60mm", 0, 1);
          LODOP.ADD_PRINT_LINE("114mm", "60mm", "114mm", "76mm", 0, 1);
          LODOP.ADD_PRINT_LINE("130mm", "60mm", "48mm", "60mm", 0, 1);

          LODOP.ADD_PRINT_IMAGE("1.06mm", "1.59mm", "23.02mm", "7.94mm", "url:https://img.yunchepin.cn/express_logo/sf_icon/logo/sf.png");
          LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);

          /*快递类型*/
          if (isFwsy || (objJson.SfWaybillInfo.ProName != null && objJson.SfWaybillInfo.ProName != "")) {
            LODOP.ADD_PRINT_TEXT("1.27mm", "22.75mm", "51.36mm", "9.53mm", objJson.SfWaybillInfo.ProName == '' && isFwsy ? "丰网速运" : objJson.SfWaybillInfo.ProName);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "宋体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 24);
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 3);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -4);
          }

          /*自建平台*/
          LODOP.ADD_PRINT_TEXT("10.05mm", "12.12mm", "8.2mm", "5.29mm", "ZJ");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "宋体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 6);

          /*打印时间*/
          LODOP.ADD_PRINT_TEXT("10.05mm", "26.46mm", "16.14mm", "5.03mm", "打印时间");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "宋体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 6);
          LODOP.ADD_PRINT_TEXT("10.05mm", "37.31mm", "24.34mm", "5.03mm", objJson.ExtSendDate);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "宋体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 6);

          /*物流单号*/
          LODOP.ADD_PRINT_BARCODE("16.93mm", "2.65mm", "60mm", "13mm", objJson.CodecType, objJson.WaybillCode);
          LODOP.SET_PRINT_STYLEA(0, "ShowBarText", 0);

          if (objJson.SfWaybillInfo.ProCode != null && objJson.SfWaybillInfo.ProCode != "") {
            LODOP.ADD_PRINT_IMAGE("18.52mm", "64mm", "12mm", "12mm", "url:" + objJson.SfWaybillInfo.ProCode);
            LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);
          }

          /*
          LODOP.ADD_PRINT_TEXT("30.69mm", "3.2mm", "12.53mm", "4.5mm", "1/1");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          LODOP.ADD_PRINT_TEXT("30.69mm", "13.79mm", "18.35mm", "4.5mm", "子单号：");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-2");
          LODOP.ADD_PRINT_TEXT("30.69mm", "27.56mm", "39.98mm", "4.5mm", "SF 104 044 790 1160");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-1");
          LODOP.ADD_PRINT_TEXT("34.36mm", "13.79mm", "18.35mm", "4.5mm", "母单号：");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-2");
          LODOP.ADD_PRINT_TEXT("34.36mm", "27.56mm", "39.98mm", "4.5mm", "SF 104 044 790 1160");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-1");
          */
          LODOP.ADD_PRINT_TEXT("32.56mm", "3.2mm", "12.53mm", "4.5mm", "1/1");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          LODOP.ADD_PRINT_TEXT("32.56mm", "13.79mm", "18.35mm", "4.5mm", "母单号：");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-2");
          LODOP.ADD_PRINT_TEXT("32.56mm", "27.56mm", "39.98mm", "4.5mm", objJson.SfWaybillInfo.PrintWaybillNo);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-1");

          /*大头笔or三段码*/
          if (objJson.ShortAddress != null && objJson.ShortAddress != "") {
            LODOP.ADD_PRINT_TEXT("38.89mm", "0mm", "76mm", "10.32mm", objJson.ShortAddress);
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 22);
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          }

          LODOP.ADD_PRINT_BARCODE("51.06mm", "60.85mm", "13mm", "60mm", objJson.CodecType, objJson.WaybillCode);
          LODOP.SET_PRINT_STYLEA(0, "ShowBarText", 0);
          LODOP.SET_PRINT_STYLEA(0, "Angle", 270);

          LODOP.ADD_PRINT_TEXT("55.17mm", "-0.56mm", "10.69mm", "8.65mm", "收");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 16);
          LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          let consigneeInfo = "";
          if (objJson.ConsigneeName != null && objJson.ConsigneeName != "") {
            consigneeInfo += objJson.ConsigneeName;
          }
          if (objJson.SfWaybillInfo.ReceiverPhone != null && objJson.SfWaybillInfo.ReceiverPhone != "") {
            consigneeInfo += "  " + objJson.SfWaybillInfo.ReceiverPhone;
          }
          if (objJson.SfWaybillInfo.ReceiverCompany != null && objJson.SfWaybillInfo.ReceiverCompany != "") {
            consigneeInfo += "\n" + objJson.SfWaybillInfo.ReceiverCompany;
          }
          if (objJson.ConsigneeAddress != null && objJson.ConsigneeAddress != "") {
            consigneeInfo += "\n" + objJson.ConsigneeAddress;
          }
          if (consigneeInfo != "") {
            LODOP.ADD_PRINT_TEXT("49.21mm", "10.56mm", "52.52mm", "17.73mm", consigneeInfo);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "宋体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-4");
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-1");
          }

          if (objJson.SfWaybillInfo.DestTeamCode != null && objJson.SfWaybillInfo.DestTeamCode != "") {
            LODOP.ADD_PRINT_TEXT("58.45mm", "21.34mm", "28.05mm", "10.58mm", objJson.SfWaybillInfo.DestTeamCode);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 37);
            LODOP.SET_PRINT_STYLEA(0, "FontColor", "#C0C0C0");
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
          }

          LODOP.ADD_PRINT_TEXT("68.66mm", "-0.29mm", "10.69mm", "8.65mm", "寄");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 16);
          LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          let senderInfo = "";
          if (objJson.SendName != null && objJson.SendName != "") {
            senderInfo += objJson.SendName;
          }
          if (objJson.SfWaybillInfo.SenderPhone != null && objJson.SfWaybillInfo.SenderPhone != "") {
            senderInfo += "  " + objJson.SfWaybillInfo.SenderPhone;
          }
          if (objJson.SfWaybillInfo.SenderCompany != null && objJson.SfWaybillInfo.SenderCompany != "") {
            senderInfo += "  " + objJson.SfWaybillInfo.SenderCompany;
          }
          if (senderInfo != "") {
            LODOP.ADD_PRINT_TEXT("67.65mm", "10.56mm", "52.52mm", "5.29mm", senderInfo);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "宋体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 6);
            LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-1");
          }
          if (objJson.ShippingAddress != null && objJson.ShippingAddress != "") {
            LODOP.ADD_PRINT_TEXT("69.85mm", "10.56mm", "52.52mm", "8.2mm", objJson.ShippingAddress);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "宋体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 6);
            LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-3");
          }

          if (isCod) {
            LODOP.ADD_PRINT_IMAGE("75.14mm", "0.32mm", "10mm", "5.5mm", "url:" + objJson.SfWaybillInfo.CodIcon);
            LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);
          }

          LODOP.ADD_PRINT_TEXT("76.6mm", "18.76mm", "13.07mm", "6.01mm", "已验视");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontColor", "#808080");
          LODOP.SET_PRINT_STYLEA(0, "Alignment", 3);
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-2");

          if (objJson.SfWaybillInfo.TwoDimensionCode != null && objJson.SfWaybillInfo.TwoDimensionCode != "") {
            LODOP.ADD_PRINT_BARCODE("76.2mm", "34.48mm", "31mm", "31mm", "QRCode", objJson.SfWaybillInfo.TwoDimensionCode);
            LODOP.SET_PRINT_STYLEA(0, "ShowBarText", 0);
          }

          if (objJson.SfWaybillInfo.PrintIcons) {
            if (objJson.SfWaybillInfo.PrintIcons.length > 0) {
              LODOP.ADD_PRINT_IMAGE("82.02mm", "3.7mm", "11mm", "11mm", "url:" + objJson.SfWaybillInfo.PrintIcons[0]);
              LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);
            }
            if (objJson.SfWaybillInfo.PrintIcons.length > 1) {
              LODOP.ADD_PRINT_IMAGE("82.02mm", "16.93mm", "11mm", "11mm", "url:" + objJson.SfWaybillInfo.PrintIcons[1]);
              LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);
            }
          }

          if (objJson.SfWaybillInfo.CodingMapping != null && objJson.SfWaybillInfo.CodingMapping != "") {
            LODOP.ADD_PRINT_TEXT("92.08mm", "2.65mm", "27.25mm", "13.23mm", objJson.SfWaybillInfo.CodingMapping);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 40);
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-2");
          }

          if (isCod) {
            LODOP.ADD_PRINT_TEXT("107.02mm", "1.06mm", "32.28mm", "5.29mm", "代收货款" + objJson.ServCodAmount);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "宋体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-1");
          } else {
            LODOP.ADD_PRINT_TEXT("107.02mm", "1.06mm", "32.28mm", "5.29mm", objJson.SfWaybillInfo.PayType);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "宋体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-1");
          }

          LODOP.ADD_PRINT_TEXT("107.02mm", "30.06mm", "11.56mm", "5.29mm", "签收：");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "宋体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-1");

          if (objJson.SfWaybillInfo.AbFlag != null && objJson.SfWaybillInfo.AbFlag != "") {
            LODOP.ADD_PRINT_IMAGE("117.16mm", "62.65mm", "11.01mm", "11.01mm", "url:" + objJson.SfWaybillInfo.AbFlag);
            LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);
          }

          LODOP.ADD_PRINT_TEXT("112.45mm", "0.79mm", "13.49mm", "5.03mm", "托寄物：");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "宋体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-1");
          if (objJson.ListInfo != null && objJson.ListInfo != "") {
            LODOP.ADD_PRINT_TEXT("112.45mm", "10.85mm", "48.15mm", "10.05mm", objJson.ListInfo);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-1");
          }

          if (objJson.Delivery != null && objJson.Delivery != "") {
            LODOP.ADD_PRINT_TEXT("116.84mm", "3.44mm", "52.39mm", "8.2mm", objJson.Delivery);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
            LODOP.SET_PRINT_STYLEA(0, "FontColor", "#C0C0C0");
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-3");
          }

          if (objJson.ProCount != null && objJson.ProCount != "") {
            LODOP.ADD_PRINT_TEXT("120.39mm", "43.66mm", "16.67mm", "5.29mm", "共    件");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "宋体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
            LODOP.SET_PRINT_STYLEA(0, "FontColor", "#808080");
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
            LODOP.ADD_PRINT_TEXT("119.59mm", "46.3mm", "10.58mm", "5.29mm", objJson.ProCount);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "宋体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-1");
          }

          if (objJson.OrderCode != null && objJson.OrderCode != "") {
            LODOP.ADD_PRINT_TEXT("124.35mm", "2.12mm", "7.14mm", "5.29mm", "No:");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "宋体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
            LODOP.ADD_PRINT_TEXT("124.35mm", "7.94mm", "28.58mm", "5.29mm", "【云】" + objJson.OrderCode);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "宋体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          }

          if (objJson.Shelves != null && objJson.Shelves != "") {
            LODOP.ADD_PRINT_TEXT("124.35mm", "35.98mm", "22.49mm", "5.29mm", objJson.Shelves);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "宋体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 3);
          }
        }
          break;
        case 2:
        default:
        {
          LODOP.PRINT_INITA(0, 0, "100mm", "180mm", "顺丰标准面单[新]" + (objJson.OrderId == null || objJson.OrderId == "" ? "" : " - " + objJson.OrderId));
          LODOP.SET_PRINT_PAGESIZE(0, "100mm", "180mm", "");

          /* 线条布局 */
          LODOP.ADD_PRINT_SHAPE(0, "14.61mm", "1mm", "98.5mm", "0.26mm", 0, 1, "#C0C0C0");
          LODOP.ADD_PRINT_SHAPE(0, "14.61mm", "1mm", "0.26mm", "24.29mm", 0, 1, "#C0C0C0");
          LODOP.ADD_PRINT_SHAPE(0, "14.61mm", "99mm", "0.26mm", "24.29mm", 0, 1, "#C0C0C0");
          LODOP.ADD_PRINT_LINE("38.89mm", "1mm", "38.89mm", "99mm", 0, 1);
          LODOP.ADD_PRINT_LINE("38.89mm", "1mm", "106.1mm", "1mm", 0, 1);
          LODOP.ADD_PRINT_LINE("38.89mm", "99mm", "106.1mm", "99mm", 0, 1);
          LODOP.ADD_PRINT_LINE("74.9mm", "1mm", "74.9mm", "99mm", 0, 1);
          LODOP.ADD_PRINT_LINE("84.19mm", "1mm", "84.19mm", "35.16mm", 0, 1);
          LODOP.ADD_PRINT_LINE("96.31mm", "78.36mm", "96.31mm", "99mm", 0, 1);
          LODOP.ADD_PRINT_LINE("106.1mm", "35.3mm", "75.09mm", "35.3mm", 0, 1);
          LODOP.ADD_PRINT_LINE("106.1mm", "68.29mm", "75.09mm", "68.29mm", 0, 1);
          LODOP.ADD_PRINT_LINE("106.1mm", "78.29mm", "75.09mm", "78.29mm", 0, 1);
          LODOP.ADD_PRINT_LINE("106.12mm", "1mm", "106.12mm", "99.6mm", 0, 1);
          LODOP.ADD_PRINT_LINE("111.13mm", "1mm", "111.13mm", "99mm", 0, 1);
          LODOP.ADD_PRINT_LINE("124.03mm", "50.3mm", "177.02mm", "50.3mm", 0, 1);
          LODOP.ADD_PRINT_LINE("124.14mm", "1mm", "124.14mm", "99mm", 0, 1);
          LODOP.ADD_PRINT_LINE("137.32mm", "50.64mm", "137.32mm", "99mm", 0, 1);
          LODOP.ADD_PRINT_LINE("150.02mm", "1mm", "150.02mm", "99mm", 0, 1);
          LODOP.ADD_PRINT_LINE("177.02mm", "1mm", "111.03mm", "1mm", 0, 1);
          LODOP.ADD_PRINT_LINE("177.02mm", "99mm", "111.03mm", "99mm", 0, 1);
          LODOP.ADD_PRINT_LINE("177.3mm", "1mm", "177.3mm", "99.6mm", 0, 1);

          LODOP.ADD_PRINT_IMAGE("1.06mm", "1.59mm", "23.02mm", "7.94mm", "url:https://img.yunchepin.cn/express_logo/sf_icon/logo/sf.png");
          LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);

          /*快递类型*/
          if (objJson.SfWaybillInfo.ProName != null && objJson.SfWaybillInfo.ProName != "") {
            LODOP.ADD_PRINT_TEXT("1.26mm", "44.19mm", "54mm", "9.53mm", objJson.SfWaybillInfo.ProName);
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 24);
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 3);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -4);
          }

          /*自建平台*/
          LODOP.ADD_PRINT_TEXT("11.38mm", "19.79mm", "8.2mm", "5.29mm", "ZJ");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 6);
          //LODOP.ADD_PRINT_TEXT("11.38mm", "24.08mm", "16.14mm", "5.29mm", "第 1 次打印");
          //LODOP.SET_PRINT_STYLEA(0, "FontSize", 6);

          /*打印时间*/
          LODOP.ADD_PRINT_TEXT("11.38mm", "40.75mm", "16.14mm", "5.03mm", "打印时间:");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 6);
          LODOP.ADD_PRINT_TEXT("11.38mm", "51.59mm", "24.34mm", "5.03mm", objJson.ExtSendDate);
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 6);

          /*物流单号*/
          LODOP.ADD_PRINT_BARCODE("16.93mm", "2.65mm", "75.25mm", "12.99mm", objJson.CodecType, objJson.WaybillCode);
          LODOP.SET_PRINT_STYLEA(0, "ShowBarText", 0);

          /*
          LODOP.ADD_PRINT_TEXT("30.69mm", "8.2mm", "9.53mm", "4.5mm", "1/1");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.ADD_PRINT_TEXT("30.69mm", "18.79mm", "15.35mm", "4.5mm", "子单号：");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.ADD_PRINT_TEXT("30.69mm", "34.93mm", "35.98mm", "4.5mm", objJson.SfWaybillInfo.PrintWaybillNo);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.ADD_PRINT_TEXT("34.66mm", "18.79mm", "15.35mm", "4.5mm", "母单号：");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.ADD_PRINT_TEXT("34.66mm", "34.93mm", "35.98mm", "4.5mm", objJson.SfWaybillInfo.PrintWaybillNo);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          */
          LODOP.ADD_PRINT_TEXT("32.69mm", "8.2mm", "9.53mm", "4.5mm", "1/1");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.ADD_PRINT_TEXT("32.69mm", "18.79mm", "15.35mm", "4.5mm", "母单号：");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.ADD_PRINT_TEXT("32.69mm", "34.93mm", "35.98mm", "4.5mm", objJson.SfWaybillInfo.PrintWaybillNo);

          if (objJson.SfWaybillInfo.ProCode != null && objJson.SfWaybillInfo.ProCode != "") {
            LODOP.ADD_PRINT_IMAGE("18.52mm", "81.6mm", "16.01mm", "16.00mm", "url:" + objJson.SfWaybillInfo.ProCode);
            LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);
          }

          if (objJson.ShortAddress != null && objJson.ShortAddress != "") {
            LODOP.ADD_PRINT_TEXT("38.89mm", "1.59mm", "97.1mm", "10.32mm", objJson.ShortAddress);
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 30);
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          }

          if (isCod) {
            LODOP.ADD_PRINT_IMAGE("49.21mm", "82.39mm", "17mm", "9mm", "url:" + objJson.SfWaybillInfo.CodIcon);
            LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);
          }

          LODOP.ADD_PRINT_IMAGE("55.03mm", "1.96mm", "10mm", "10mm", "url:https://img.yunchepin.cn/express_logo/sf_icon/from_to/shou.png");
          LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);
          let consigneeInfo = "";
          if (objJson.ConsigneeName != null && objJson.ConsigneeName != "") {
            consigneeInfo += objJson.ConsigneeName;
          }
          if (objJson.SfWaybillInfo.ReceiverPhone != null && objJson.SfWaybillInfo.ReceiverPhone != "") {
            consigneeInfo += "  " + objJson.SfWaybillInfo.ReceiverPhone;
          }
          if (consigneeInfo != "") {

            LODOP.ADD_PRINT_TEXT("50.54mm", "12.05mm", "72.23mm", "5.03mm", consigneeInfo);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          }

          if (objJson.SfWaybillInfo.ReceiverCompany != null && objJson.SfWaybillInfo.ReceiverCompany != "") {
            LODOP.ADD_PRINT_TEXT("54.77mm", "12.05mm", "72.23mm", "5.29mm", objJson.SfWaybillInfo.ReceiverCompany);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          }

          if (objJson.ConsigneeAddress != null && objJson.ConsigneeAddress != "") {
            LODOP.ADD_PRINT_TEXT("59.27mm", "12.05mm", "72.23mm", "13.76mm", objJson.ConsigneeAddress);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
          }

          if (objJson.SfWaybillInfo.DestTeamCode != null && objJson.SfWaybillInfo.DestTeamCode != "") {
            LODOP.ADD_PRINT_TEXT("60.45mm", "33.34mm", "28.05mm", "10.58mm", objJson.SfWaybillInfo.DestTeamCode);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 37);
            LODOP.SET_PRINT_STYLEA(0, "FontColor", "#C0C0C0");
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
          }

          if (isCod) {
            LODOP.ADD_PRINT_TEXT("76.46mm", "2.12mm", "30.69mm", "6.09mm", "代收货款" + objJson.ServCodAmount);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "Arial");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            //LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
          } else {
            LODOP.ADD_PRINT_TEXT("76.46mm", "2.12mm", "30.69mm", "6.09mm", objJson.SfWaybillInfo.PayType);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "Arial");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
          }

          if (objJson.SfWaybillInfo.CodingMapping != null && objJson.SfWaybillInfo.CodingMapping != "") {
            LODOP.ADD_PRINT_TEXT("87.84mm", "2.12mm", "30.96mm", "19.31mm", objJson.SfWaybillInfo.CodingMapping);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 40);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
          }

          if (objJson.SfWaybillInfo.TwoDimensionCode != null && objJson.SfWaybillInfo.TwoDimensionCode != "") {
            LODOP.ADD_PRINT_BARCODE("76.99mm", "38.1mm", "30mm", "30mm", "QRCode", objJson.SfWaybillInfo.TwoDimensionCode);
            LODOP.SET_PRINT_STYLEA(0, "ShowBarText", 0);
          }

          LODOP.ADD_PRINT_TEXT("79.76mm", "69.56mm", "8.2mm", "26.46mm", "已验视");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 20);
          LODOP.SET_PRINT_STYLEA(0, "FontColor", "#808080");
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -12);

          if (objJson.SfWaybillInfo.AbFlag != null && objJson.SfWaybillInfo.AbFlag != "") {
            LODOP.ADD_PRINT_IMAGE("75.94mm", "81.05mm", "15mm", "19mm", "url:" + objJson.SfWaybillInfo.AbFlag);
            LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);
          }

          if (objJson.SfWaybillInfo.CodingMappingOut != null && objJson.SfWaybillInfo.CodingMappingOut != "") {
            LODOP.ADD_PRINT_TEXT("96.04mm", "78.58mm", "19.05mm", "7.94mm", objJson.SfWaybillInfo.CodingMappingOut);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 30);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
          }

          LODOP.ADD_PRINT_IMAGE("111.65mm", "1.59mm", "19.31mm", "11.91mm", "url:https://img.yunchepin.cn/express_logo/sf_icon/logo/shunfeng.png");
          LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);
          LODOP.ADD_PRINT_IMAGE("112.98mm", "21.96mm", "10mm", "10mm", "url:https://img.yunchepin.cn/express_logo/sf_icon/from_to/ji.png");
          LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);

          let senderInfo = "";
          if (objJson.SendName != null && objJson.SendName != "") {
            senderInfo += objJson.SendName;
          }
          if (objJson.SfWaybillInfo.SenderPhone != null && objJson.SfWaybillInfo.SenderPhone != "") {
            senderInfo += "  " + objJson.SfWaybillInfo.SenderPhone;
          }
          if (objJson.SfWaybillInfo.SenderCompany != null && objJson.SfWaybillInfo.SenderCompany != "") {
            senderInfo += "  " + objJson.SfWaybillInfo.SenderCompany;
          }
          if (senderInfo != "") {
            LODOP.ADD_PRINT_TEXT("112.36mm", "31.99mm", "65.88mm", "5.29mm", senderInfo);
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -1);
          }

          if (objJson.ShippingAddress != null && objJson.ShippingAddress != "") {
            LODOP.ADD_PRINT_TEXT("115.89mm", "32.25mm", "65.88mm", "8.2mm", objJson.ShippingAddress);
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
          }

          LODOP.ADD_PRINT_TEXT("125.15mm", "2.65mm", "13.49mm", "5.03mm", "托寄物：");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
          if (objJson.ListInfo != null && objJson.ListInfo != "") {
            LODOP.ADD_PRINT_TEXT("128.85mm", "2.38mm", "46.83mm", "21.17mm", objJson.ListInfo);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
          }

          LODOP.ADD_PRINT_TEXT("125.15mm", "50.8mm", "16.14mm", "5.56mm", "增值服务：");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
          if (isCod) {
            LODOP.ADD_PRINT_TEXT("125.15mm", "63.24mm", "34.69mm", "11.64mm", "货到付款");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
          }

          LODOP.ADD_PRINT_TEXT("138.14mm", "50.8mm", "16.4mm", "5.29mm", "计费重量：");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
          LODOP.ADD_PRINT_TEXT("138.14mm", "63.24mm", "12.44mm", "5.29mm", "");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
          LODOP.ADD_PRINT_TEXT("138.14mm", "74.08mm", "16.4mm", "5.29mm", "实际重量：");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
          LODOP.ADD_PRINT_TEXT("138.14mm", "86.52mm", "12.44mm", "5.29mm", "");
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);

          LODOP.ADD_PRINT_TEXT("141.95mm", "50.8mm", "16.4mm", "5.29mm", "费用合计：");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
          if (isCod) {
            LODOP.ADD_PRINT_TEXT("141.95mm", "63.24mm", "35.45mm", "5.29mm", objJson.ServCodAmount);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            //LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
          }
          LODOP.ADD_PRINT_TEXT("145.96mm", "50.8mm", "16.4mm", "5.29mm", "付款方式：");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
          if (objJson.SfWaybillInfo.PayType != null && objJson.SfWaybillInfo.PayType != "") {
            LODOP.ADD_PRINT_TEXT("145.96mm", "63.24mm", "35.45mm", "5.29mm", objJson.SfWaybillInfo.PayType);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
          }

          if (objJson.SfWaybillInfo.PrintIcons) {
            if (objJson.SfWaybillInfo.PrintIcons.length > 0) {
              LODOP.ADD_PRINT_IMAGE("153.46mm", "53.18mm", "21mm", "21mm", "url:" + objJson.SfWaybillInfo.PrintIcons[0]);
              LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);
            }
            if (objJson.SfWaybillInfo.PrintIcons.length > 1) {
              LODOP.ADD_PRINT_IMAGE("153.19mm", "76.99mm", "21mm", "21mm", "url:" + objJson.SfWaybillInfo.PrintIcons[1]);
              LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);
            }
          }

          /*商品清单*/
          LODOP.ADD_PRINT_TEXT("151.34mm", "2.38mm", "47.1mm", "21.96mm", "");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);

          if (objJson.Delivery != null && objJson.Delivery != "") {
            LODOP.ADD_PRINT_TEXT("160.22mm", "0.26mm", "52.39mm", "8.2mm", objJson.Delivery);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
            LODOP.SET_PRINT_STYLEA(0, "FontColor", "#C0C0C0");
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -3);
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
          }

          if (objJson.ProCount != null && objJson.ProCount != "") {
            LODOP.ADD_PRINT_TEXT("169.6mm", "34.13mm", "16.67mm", "5.29mm", "共    件");
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
            LODOP.SET_PRINT_STYLEA(0, "FontColor", "#808080");
            LODOP.ADD_PRINT_TEXT("168.8mm", "36.78mm", "10.58mm", "5.29mm", objJson.ProCount);
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
          }

          if (objJson.OrderCode != null && objJson.OrderCode != "") {
            LODOP.ADD_PRINT_TEXT("173.57mm", "2.12mm", "7.14mm", "5.29mm", "No:");
            LODOP.ADD_PRINT_TEXT("173.57mm", "7.94mm", "28.58mm", "5.29mm", "【云】" + objJson.OrderCode);
          }

          if (objJson.Shelves != null && objJson.Shelves != "") {
            LODOP.ADD_PRINT_TEXT("173.57mm", "35.98mm", "18.52mm", "5.29mm", objJson.Shelves);
          }
        }
          break;
      }

      if (this.findMachine || (!this.findMachine && this.getPrinter(objJson))) {
        switch (that.a.EBill.printType) {
          case 1: /*预览*/
            LODOP.PREVIEW();
            break;
          case 2: /*打印*/
            // LODOP.PRINT();

            // 打印并获取打印任务号
            var printTaskId = LODOP.PRINT();
            // 监听打印完成状态
            LODOP.On_Return=function(TaskID, Value){//TaskID:任务id，Value：job代码
              if (TaskID === printTaskId) {
                // 打印完成
                if(Value){
                  alert("打印成功");
                }else {
                  alert("打印失败");
                }
              }
            };
            break;
        }
      }
    },

    JingDongPrint: function (LODOP, objJson) {
      let isCod = objJson.ServCodAmount && objJson.ServCodAmount != ""; /*是否代收货款件*/

      switch (objJson.TemplateType) {
        case 1:
        {
          LODOP.PRINT_INITA("0mm", "0mm", "76mm", "130mm", "京东物流一联单" + (objJson.OrderId == null || objJson.OrderId == "" ? "" : " - " + objJson.OrderId));
          LODOP.SET_PRINT_PAGESIZE(0, "76mm", "130mm", "");

          /*线条布局*/
          LODOP.ADD_PRINT_LINE("20.88mm", "0mm", 78, "75.91mm", 0, 1);
          LODOP.ADD_PRINT_LINE("38.07mm", "0mm", 143, "75.91mm", 0, 1);
          LODOP.ADD_PRINT_LINE("43.15mm", "0mm", 162, "75.91mm", 0, 1);
          LODOP.ADD_PRINT_LINE("63.76mm", "0mm", 240, "75.91mm", 0, 1);
          LODOP.ADD_PRINT_LINE("74.56mm", "0mm", 281, "75.91mm", 0, 1);
          LODOP.ADD_PRINT_LINE("98.16mm", "0mm", 370, "75.91mm", 0, 1);
          LODOP.ADD_PRINT_LINE("119.35mm", "0mm", 450, "75.91mm", 0, 1);
          LODOP.ADD_PRINT_LINE("55.85mm", "53.39mm", 210, "53.39mm", 0, 1);
          LODOP.ADD_PRINT_LINE("63.82mm", "58.21mm", "37.86mm", 221, 0, 1);
          LODOP.ADD_PRINT_LINE("63.45mm", "50.01mm", "42.6mm", 190, 0, 1);
          LODOP.ADD_PRINT_LINE("37.81mm", "39.4mm", "20.64mm", 150, 0, 1);
          LODOP.ADD_PRINT_LINE("42.89mm", "45.19mm", "20.61mm", 172, 0, 1);
          LODOP.ADD_PRINT_LINE("63.21mm", "5.79mm", "20.61mm", 23, 0, 1);
          LODOP.ADD_PRINT_LINE("53.47mm", "50.3mm", 201, "75.7mm", 0, 1);
          LODOP.ADD_PRINT_LINE("103.77mm", "0mm", 391, "75.91mm", 0, 1);
          LODOP.ADD_PRINT_LINE("103.8mm", 103, "98mm", 103, 0, 1);
          LODOP.ADD_PRINT_LINE("129.88mm", "53.42mm", "74.08mm", 203, 0, 1);

          /* 物流单号（上）*/
          LODOP.ADD_PRINT_BARCODE("3.44mm", "6.35mm", "64.82mm", "15.88mm", objJson.CodecType, objJson.WaybillCode + "-1-1-");

          /*始发地*/
          LODOP.ADD_PRINT_TEXT("22.49mm", "1.59mm", "5.03mm", "16.67mm", "始发地");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          if (objJson.ShippingBranchName != null && objJson.ShippingBranchName != '') {
            LODOP.ADD_PRINT_TEXT("22.23mm", "7.14mm", "31.49mm", "8.2mm", objJson.ShippingBranchName);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-0.33mm");
          }
          /*始发地三段码*/
          if (objJson.ShippingBranchCode != null && objJson.ShippingBranchCode != '') {
            LODOP.ADD_PRINT_TEXT("30.43mm", "7.14mm", "31.49mm", "6.61mm", objJson.ShippingBranchCode);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          }

          /*目的地：用集包地名称代替*/
          LODOP.ADD_PRINT_TEXT("21.96mm", "40.48mm", "6.35mm", "16.14mm", "目的地");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          if (objJson.PackageCenterName != null && objJson.PackageCenterName != '') {
            LODOP.ADD_PRINT_TEXT("22.23mm", "47.1mm", "27.99mm", "8.2mm", objJson.PackageCenterName);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-0.33mm");
          }
          /*目的地三段码：用集包地代码代替*/
          if (objJson.PackageCenterCode != null && objJson.PackageCenterCode != '') {
            LODOP.ADD_PRINT_TEXT("30.43mm", "47.1mm", "27.99mm", "6.61mm", objJson.PackageCenterCode);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          }

          /*目的地站点：用大头笔代替*/
          if (objJson.ShortAddress != null && objJson.ShortAddress != '') {
            LODOP.ADD_PRINT_TEXT("39.16mm", "8.47mm", "26.46mm", "5.29mm", objJson.ShortAddress);
          }
          /*路区：用大头笔代替*/
          if (objJson.Service != null && objJson.Service != '') {
            LODOP.ADD_PRINT_TEXT("38.89mm", "47.89mm", "12.7mm", "5.29mm", objJson.Service);
          }
          /*第几件/总件数*/
          LODOP.ADD_PRINT_TEXT("38.89mm", "64.29mm", "10.85mm", "5.29mm", "1/1");

          /*收件信息（上）*/
          LODOP.ADD_PRINT_TEXT("44.45mm", "1.59mm", "5.29mm", "20.11mm", "收件信息");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.ADD_PRINT_TEXT("44.98mm", "8.47mm", "41.01mm", "12.17mm", objJson.ConsigneeAddress);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-0.53mm");
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
          LODOP.ADD_PRINT_TEXT("58.47mm", "8.47mm", "41.01mm", "5.29mm", objJson.ConsigneeName + " " + objJson.ConsigneePhone);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);

          /*签字栏*/
          LODOP.ADD_PRINT_TEXT("44.45mm", "51.33mm", "9.26mm", "10.32mm", "客户签字");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          /*COD代收货款信息*/
          if (isCod) {
            LODOP.ADD_PRINT_TEXT("54.5mm", "51.06mm", "9.53mm", "11.11mm", "应收金额");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.ADD_PRINT_TEXT("56.62mm", "59mm", "17.2mm", "6.61mm", "￥" + objJson.ServCodAmount);
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          }
          /*发件日期*/
          LODOP.ADD_PRINT_TEXT("64.03mm", "58.21mm", "19.58mm", "5.29mm", objJson.ExtSendDate);
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 6);

          /*物流单号（下）*/
          LODOP.ADD_PRINT_TEXT("66.94mm", "12.73mm", "16.67mm", "6.61mm", "运单号：");
          LODOP.ADD_PRINT_TEXT("66.94mm", "24.87mm", "34.66mm", "6.61mm", objJson.WaybillCode);
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);

          /*收件信息（下）*/
          LODOP.ADD_PRINT_TEXT("75.67mm", "1.59mm", "17.99mm", "6.61mm", "收件信息：");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.ADD_PRINT_TEXT("75.67mm", "11.91mm", "37.04mm", "7.94mm", objJson.ConsigneeName + " " + objJson.ConsigneePhone);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
          LODOP.ADD_PRINT_BARCODE("83.61mm", "1.85mm", "53.71mm", "13.23mm", objJson.CodecType, objJson.WaybillCode);

          /*运单备注*/
          LODOP.ADD_PRINT_TEXT("75.14mm", "54.24mm", "12.17mm", "6.61mm", "备注：");
          if (objJson.ProCount != null && objJson.ProCount != "") {
            LODOP.ADD_PRINT_TEXT("93.4mm", "56.62mm", "5.82mm", "5.29mm", "共");
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
            LODOP.ADD_PRINT_TEXT("92.6mm", "59.8mm", "9.66mm", "5.29mm", objJson.ProCount);
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-0.26mm");
            LODOP.ADD_PRINT_TEXT("93.4mm", "67.73mm", "5.29mm", "5.29mm", "件");
          }

          /*产品时效*/
          if (objJson.ExtSfBizType != null && objJson.ExtSfBizType != '') {
            LODOP.ADD_PRINT_TEXT(374, 5, 85, 20, objJson.ExtSfBizType);
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          }
          /*产品类型*/
          if (objJson.ProductType != null && objJson.ProductType != '') {
            LODOP.ADD_PRINT_TEXT(374, 108, 85, 20, objJson.ProductType);
            LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          }

          /*寄方信息*/
          LODOP.ADD_PRINT_TEXT("103.72mm", "1.32mm", "19.84mm", "6.61mm", "寄方信息：");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.ADD_PRINT_TEXT("107.16mm", "1.32mm", "51.86mm", "9.53mm", objJson.ShippingAddress);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", "-0.53mm");
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
          LODOP.ADD_PRINT_TEXT("115.89mm", "1.59mm", "52.12mm", "5.29mm", objJson.SendName + " " + objJson.SendPhone);
          LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);

          /*签收提示*/
          LODOP.ADD_PRINT_TEXT("104.25mm", "54.24mm", "22.54mm", "16.14mm", "请您确认包裹完好，保留此包裹联时，代表您已经正常签收并确认外包裹完好");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
          LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -0.5);

          if (objJson.OrderCode != null && objJson.OrderCode != "") {
            LODOP.ADD_PRINT_TEXT("120.65mm", "1.32mm", "7.94mm", "5.29mm", "No:");
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
            LODOP.ADD_PRINT_TEXT("120.65mm", "6.09mm", "28.05mm", "5.29mm", "【云】" + objJson.OrderCode);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          }
          if (objJson.Delivery != null && objJson.Delivery != "") {
            LODOP.ADD_PRINT_TEXT("124.88mm", "1.32mm", "31.75mm", "5.29mm", objJson.Delivery);
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          }
          if (objJson.Shelves != null && objJson.Shelves != "") {
            LODOP.ADD_PRINT_TEXT("124.88mm", "37.57mm", "15.88mm", "5.29mm", objJson.Shelves);
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          }

          /*始发城市*/
          LODOP.ADD_PRINT_TEXT("119.86mm", "54.5mm", "16.67mm", "5.29mm", "始发城市");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          if (objJson.ShippingAddressCity != null && objJson.ShippingAddressCity != '') {
            LODOP.ADD_PRINT_TEXT("124.09mm", "57.15mm", "16.93mm", "5.29mm", objJson.ShippingAddressCity);
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
            LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          }
        }
          break;
        case 2:
        default:
        {
          LODOP.PRINT_INITA("0mm", "0mm", "100mm", "180mm", "京东物流标准面单" + (objJson.OrderId == null || objJson.OrderId == "" ? "" : " - " + objJson.OrderId));
          LODOP.SET_PRINT_PAGESIZE(0, "100mm", "180mm", "");

          LODOP.ADD_PRINT_SHAPE(4, "20.64mm", "0mm", "105.83mm", "0.26mm", 0, 1, "#000000");
          LODOP.ADD_PRINT_SHAPE(4, "37.84mm", "0mm", "105.83mm", "0.26mm", 0, 1, "#000000");
          LODOP.ADD_PRINT_SHAPE(4, "42.86mm", "0mm", "105.83mm", "0.26mm", 0, 1, "#000000");
          LODOP.ADD_PRINT_SHAPE(4, "63.5mm", "0mm", "105.83mm", "0.26mm", 0, 1, "#000000");
          LODOP.ADD_PRINT_SHAPE(4, "20.64mm", "8.2mm", "0.26mm", "43.13mm", 0, 1, "#000000")
          LODOP.ADD_PRINT_SHAPE(4, "20.64mm", "53.18mm", "0.26mm", "17.2mm", 0, 1, "#000000");
          LODOP.ADD_PRINT_SHAPE(4, "20.64mm", "60.33mm", "0.26mm", "22.49mm", 0, 1, "#000000");
          LODOP.ADD_PRINT_SHAPE(4, "37.84mm", "83.61mm", "0.26mm", "25.66mm", 0, 1, "#000000");
          LODOP.ADD_PRINT_SHAPE(4, "42.86mm", "74.88mm", "0.26mm", "20.9mm", 0, 1, "#000000");
          LODOP.ADD_PRINT_SHAPE(4, "53.18mm", "75.14mm", "30.43mm", "0.26mm", 0, 1, "#000000");
          LODOP.ADD_PRINT_SHAPE(4, "112.45mm", "0mm", "105.83mm", "0.26mm", 0, 1, "#000000");
          LODOP.ADD_PRINT_SHAPE(4, "121.97mm", "0mm", "105.83mm", "0.26mm", 0, 1, "#000000");
          LODOP.ADD_PRINT_SHAPE(4, "145.52mm", "0mm", "105.83mm", "0.26mm", 0, 1, "#000000");
          LODOP.ADD_PRINT_SHAPE(4, "166.69mm", "0mm", "105.83mm", "0.26mm", 0, 1, "#000000");
          LODOP.ADD_PRINT_SHAPE(4, "177.54mm", "0mm", "105.83mm", "0.26mm", 0, 1, "#000000");
          LODOP.ADD_PRINT_SHAPE(4, "121.97mm", "67.73mm", "0.26mm", "55.56mm", 0, 1, "#000000");

          LODOP.ADD_PRINT_BARCODE("3.44mm", "14.82mm", "75.14mm", "15.88mm", "128A", objJson.WaybillCode);/*物流单号*/
          LODOP.ADD_PRINT_TEXT("21.96mm", "1.59mm", "5.03mm", "16.67mm", "始发地");
          if (objJson.ShippingBranchName != null && objJson.ShippingBranchName != '') {
            LODOP.ADD_PRINT_TEXT("22.23mm", "10.58mm", "40.22mm", "6.88mm", objJson.ShippingBranchName);/*发件网点名称*/
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
          }
          if (objJson.ShippingBranchCode != null && objJson.ShippingBranchCode != '') {
            LODOP.ADD_PRINT_TEXT("30.43mm", "10.58mm", "40.75mm", "6.61mm", objJson.ShippingBranchCode);/*发件网点代码*/
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
          }
          LODOP.ADD_PRINT_TEXT("21.96mm", "53.71mm", "6.35mm", "16.14mm", "目的地");
          if (objJson.PackageCenterName != null && objJson.PackageCenterName != '') {
            LODOP.ADD_PRINT_TEXT("22.23mm", "62.44mm", "26.46mm", "6.61mm", objJson.PackageCenterName);/*目的网点代码*/
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
          }
          if (objJson.PackageCenterCode != null && objJson.PackageCenterCode != '') {
            LODOP.ADD_PRINT_TEXT("30.43mm", "62.18mm", "26.46mm", "6.61mm", objJson.PackageCenterCode);/*目的网点代码*/
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
          }
          if (objJson.ShortAddress != null && objJson.ShortAddress != '') {
            LODOP.ADD_PRINT_TEXT("39.16mm", "10.58mm", "26.46mm", "5.29mm", objJson.ShortAddress);/*收件网点*/
          }
          /*路区：用大头笔代替*/
          if (objJson.Service != null && objJson.Service != '') {
            LODOP.ADD_PRINT_TEXT("38.63mm", "70.11mm", "5.82mm", "5.29mm", "1");
          }
          LODOP.ADD_PRINT_TEXT("38.89mm", "83.87mm", "15.08mm", "5.29mm", "1/1");
          LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
          LODOP.ADD_PRINT_TEXT("44.45mm", "1.59mm", "5.29mm", "20.11mm", "收件信息");
          LODOP.ADD_PRINT_TEXT("45.24mm", "10.58mm", "62.97mm", "12.17mm", objJson.ConsigneeAddress);/*收件地址*/
          LODOP.ADD_PRINT_TEXT("58.47mm", "10.58mm", "62.97mm", "5.29mm", objJson.ConsigneeName + " " + objJson.ConsigneePhone);/*收件人名字 + 电话*/
          LODOP.ADD_PRINT_TEXT("44.19mm", "76.46mm", "9.26mm", "10.32mm", "客户签字");
          LODOP.ADD_PRINT_TEXT("54.5mm", "76.2mm", "9.53mm", "11.11mm", "应收金额");
          if (objJson.ServCodAmount != null && objJson.ServCodAmount != "" && objJson.ServCodAmount != "0") {
            LODOP.ADD_PRINT_TEXT("56.62mm", "84.14mm", "22.49mm", "6.61mm", '￥' + objJson.ServCodAmount);/*代收货款*/
            LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
            LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          }
          LODOP.ADD_PRINT_TEXT("65.88mm", "74.61mm", "26.46mm", "5.29mm", objJson.ExtSendDate);/*打印日期*/

          LODOP.ADD_PRINT_TEXT("115.36mm", "27.52mm", "16.67mm", "6.61mm", "运单号：");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
          LODOP.ADD_PRINT_TEXT("115.09mm", "40.48mm", "45.77mm", "6.61mm", objJson.WaybillCode);/*物流单号*/
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
          LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
          LODOP.ADD_PRINT_TEXT("123.03mm", "2.65mm", "23.28mm", "6.61mm", "收件信息：");
          LODOP.ADD_PRINT_BARCODE("131.76mm", "6.88mm", "57.94mm", "13.23mm", "128A", objJson.WaybillCode);/*物流单号*/
          LODOP.ADD_PRINT_TEXT("123.21mm", "19.58mm", "48.95mm", "7.94mm", objJson.ConsigneeName + " " + objJson.ConsigneePhone);/*收件人名字 + 电话*/
          LODOP.ADD_PRINT_TEXT("123.03mm", "70.11mm", "12.17mm", "6.61mm", "备注：");
          LODOP.ADD_PRINT_TEXT("127.79mm", "69.32mm", "29.32mm", "15.61mm", objJson.Service);/*备注*/
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
          LODOP.ADD_PRINT_TEXT("146.05mm", "70.11mm", "26.46mm", "6.61mm", "客户签字：");
          LODOP.ADD_PRINT_TEXT("146.84mm", "2.38mm", "19.84mm", "6.61mm", "寄方信息：");
          LODOP.ADD_PRINT_TEXT("151.08mm", "2.38mm", "64.03mm", "9.53mm", objJson.ShippingAddress);/*寄件地址*/
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          LODOP.ADD_PRINT_TEXT("160.6mm", "2.38mm", "63.5mm", "5.29mm", objJson.SendName + " " + objJson.SendPhone);/*寄件人名字 + 电话*/
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
          LODOP.ADD_PRINT_TEXT("167.22mm", "2.12mm", "64.03mm", "11.11mm", "请您确认包裹完好，保留此包裹联时，代表您已经正常签收并确认外包裹完好");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
          LODOP.ADD_PRINT_TEXT("167.22mm", "70.38mm", "26.46mm", "5.29mm", "始发城市：");
          LODOP.ADD_PRINT_TEXT("172.24mm", "70.38mm", "26.46mm", "5.29mm", objJson.ShippingAddressCity);/*始发城市*/
        }
          break;
      }

      if (this.findMachine || (!this.findMachine && this.getPrinter(objJson))) {
        switch (that.a.EBill.printType) {
          case 1: /*预览*/
            LODOP.PREVIEW();
            break;
          case 2: /*打印*/
            // LODOP.PRINT();

            // 打印并获取打印任务号
            var printTaskId = LODOP.PRINT();
            // 监听打印完成状态
            LODOP.On_Return=function(TaskID, Value){//TaskID:任务id，Value：job代码
              if (TaskID === printTaskId) {
                // 打印完成
                if(Value){
                  alert("打印成功");
                }else {
                  alert("打印失败");
                }
              }
            };
            break;
        }
      }
    },
    AnnengPrint: function (LODOP, objJson) {
      LODOP.PRINT_INITA(0, 0, "100mm", "180mm", "安能物流一联单" + (objJson.OrderId == null || objJson.OrderId == "" ? "" : " - " + objJson.OrderId));
      LODOP.SET_PRINT_PAGESIZE(0, "100mm", "180mm", "");

      /*线条布局*/
      LODOP.ADD_PRINT_LINE("38.36mm", 4, 144, 374, 0, 1);
      LODOP.ADD_PRINT_LINE(360, 260, 221, 261, 0, 1);
      LODOP.ADD_PRINT_LINE(257, 260, 256, 376, 0, 1);
      LODOP.ADD_PRINT_LINE(565, 4, 564, 374, 0, 1);
      LODOP.ADD_PRINT_LINE(524, 4, 523, 283, 0, 1);
      LODOP.ADD_PRINT_LINE(473, 4, 472, 374, 0, 1);
      LODOP.ADD_PRINT_LINE(361, 4, 360, 374, 0, 1);
      LODOP.ADD_PRINT_LINE("16.67mm", 4, 62, 374, 0, 1);
      LODOP.ADD_PRINT_LINE(302, 4, 301, 260, 0, 1);
      LODOP.ADD_PRINT_LINE(222, 0, 221, 378, 0, 1);
      LODOP.ADD_PRINT_LINE(360, 26, 221, 27, 0, 1);
      LODOP.ADD_PRINT_LINE(416, 0, 416, 378, 0, 1);
      LODOP.ADD_PRINT_LINE(640, 26, 472, 27, 0, 1);
      LODOP.ADD_PRINT_LINE(472, 283, 564, 284, 0, 1);
      LODOP.ADD_PRINT_LINE(416, 150, 360, 151, 0, 1);
      LODOP.ADD_PRINT_LINE(416, 260, 360, 261, 0, 1);
      LODOP.ADD_PRINT_LINE(642, 4, 641, 374, 0, 1);

      /*快递公司logo*/
      LODOP.ADD_PRINT_IMAGE(4, 6, 68, 50, "URL:https://img.yunchepin.cn/express_logo/CN7000001000869.png");
      LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);

      /*大头笔*/
      if (objJson.ShortAddress != null && objJson.ShortAddress != '') {
        LODOP.ADD_PRINT_TEXT("20mm", 6, 365, 55, objJson.ShortAddress);/*例："021x-300-096"*/
        LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
        LODOP.SET_PRINT_STYLEA(0, "FontSize", 36);
        LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
        LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
        LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
      }

      /*物流编号*/
      LODOP.ADD_PRINT_BARCODE(151, "45pt", 300, "51pt", objJson.CodecType, objJson.WaybillCode);

      /*收件*/
      LODOP.ADD_PRINT_TEXT(251, 7, 22, 40, "收件");
      LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
      LODOP.ADD_PRINT_TEXT(225, 33, 71, 19, objJson.ConsigneeName);
      LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
      LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
      LODOP.ADD_PRINT_TEXT(225, 103, 192, 19, objJson.ConsigneePhone);
      LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
      LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
      LODOP.ADD_PRINT_TEXT(241, 33, 227, 52, objJson.ConsigneeAddress);
      LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
      LODOP.SET_PRINT_STYLEA(0, "Bold", 1);

      /*寄件日期*/
      LODOP.ADD_PRINT_TEXT(289, 121, 61, 19, "打印时间：");
      LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
      LODOP.ADD_PRINT_TEXT(289, 169, 92, 19, objJson.ExtSendDate);
      LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);

      /*寄件*/
      LODOP.ADD_PRINT_TEXT(317, 7, 22, 40, "寄件");
      LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
      LODOP.ADD_PRINT_TEXT(305, 32, 227, 30, objJson.ShippingAddress);
      LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
      LODOP.ADD_PRINT_TEXT(344, 32, 71, 19, objJson.SendName);
      LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
      LODOP.ADD_PRINT_TEXT(344, 102, 158, 19, objJson.SendPhone);
      LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);

      /*服务*/
      LODOP.ADD_PRINT_TEXT(229, 290, 54, 29, "服务");
      LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
      LODOP.SET_PRINT_STYLEA(0, "Bold", 1);

      /*实际重量*/
      LODOP.ADD_PRINT_TEXT(261, 266, 73, 20, "实际重量：");
      LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
      LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);

      /*签收栏*/
      LODOP.ADD_PRINT_TEXT(364, 8, 158, 53, "您的签字代表您已验收此包裹，并确认商品完好无损，没有划痕，没有损坏等质量问题。");
      LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
      LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
      LODOP.ADD_PRINT_TEXT(368, 154, 50, 20, "签收人：");
      LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
      LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
      LODOP.ADD_PRINT_TEXT(388, 154, 50, 20, "时间：");
      LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
      LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
      LODOP.ADD_PRINT_TEXT(365, 268, 50, 20, "收件员：");
      LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
      LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
      LODOP.ADD_PRINT_TEXT(381, 268, 60, 20, "寄件日期：");
      LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
      LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);
      LODOP.ADD_PRINT_TEXT(397, 268, 50, 20, "派件员：");
      LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
      LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -2);

      /*快递公司logo*/
      LODOP.ADD_PRINT_IMAGE(422, 6, 96, 50, "URL:https://img.yunchepin.cn/express_logo/CN7000001000869.png");
      LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);
      //LODOP.ADD_PRINT_BARCODE(151, "45pt", 265, "51pt", objJson.CodecType, objJson.WaybillCode);
      LODOP.ADD_PRINT_BARCODE(431, 130, "66mm", "10mm", objJson.CodecType, objJson.WaybillCode);

      /*收件*/
      LODOP.ADD_PRINT_TEXT(482, 7, 22, 30, "收件");
      LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
      LODOP.ADD_PRINT_TEXT(475, 32, 71, 19, objJson.ConsigneeName);
      LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
      LODOP.ADD_PRINT_TEXT(475, 102, 179, 19, objJson.ConsigneePhone);
      LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
      LODOP.ADD_PRINT_TEXT(487, 32, 253, 37, objJson.ConsigneeAddress);
      LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
      LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);

      /*寄件*/
      LODOP.ADD_PRINT_TEXT(530, 7, 22, 30, "寄件");
      LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
      LODOP.ADD_PRINT_TEXT(550, 32, 71, 19, objJson.SendName);
      LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
      LODOP.ADD_PRINT_TEXT(550, 102, 179, 19, objJson.SendPhone);
      LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
      LODOP.ADD_PRINT_TEXT(527, 32, 252, 30, objJson.ShippingAddress);
      LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
      LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);

      /*商品清单*/
      LODOP.ADD_PRINT_TEXT(571, 7, 20, 72, "内件品名");
      LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
      LODOP.ADD_PRINT_TEXT(567, 32, 345, 78, objJson.ListInfo);
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
      LODOP.SET_PRINT_STYLEA(0, "LineSpacing", -3);
      if (objJson.ProCount != null && objJson.ProCount != "") {
        LODOP.ADD_PRINT_TEXT(626, 327, 52, 20, "共   件");
        LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
        LODOP.SET_PRINT_STYLEA(0, "Horient", 1);
        LODOP.ADD_PRINT_TEXT(624, 338, 29, 20, objJson.ProCount);
        LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
        LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
        LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
        LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", -1);
      }

      if (objJson.OrderCode != null && objJson.OrderCode != "") {
        LODOP.ADD_PRINT_TEXT(647, 14, 30, 20, "No:");
        LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
        LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
        LODOP.ADD_PRINT_TEXT(647, 40, 106, 20, "【云】" + objJson.OrderCode);
        LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
        LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
      }
      if (objJson.Delivery != null && objJson.Delivery != "") {
        LODOP.ADD_PRINT_TEXT(647, 150, 120, 20, objJson.Delivery);
        LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
        LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
      }
      if (objJson.Shelves != null && objJson.Shelves != "") {
        LODOP.ADD_PRINT_TEXT(647, 280, 90, 20, objJson.Shelves);
        LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
        LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
      }
      LODOP.ADD_PRINT_TEXT(647, 330, 90, 20, "已验视");
      LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);

      if (this.findMachine || (!this.findMachine && this.getPrinter(objJson))) {
        switch (that.a.EBill.printType) {
          case 1: /*预览*/
            LODOP.PREVIEW();
            break;
          case 2: /*打印*/
            // LODOP.PRINT();

            // 打印并获取打印任务号
            var printTaskId = LODOP.PRINT();
            // 监听打印完成状态
            LODOP.On_Return=function(TaskID, Value){//TaskID:任务id，Value：job代码
              if (TaskID === printTaskId) {
                // 打印完成
                if(Value){
                  alert("打印成功");
                }else {
                  alert("打印失败");
                }
              }
            };
            break;
        }
      }
    },
    OrderPrint: function (LODOP, objJson) {
      switch (objJson.TemplateType) {
        case 1:
        {
          LODOP.PRINT_INITA("0mm", "0mm", "76mm", "130mm", "订单一联单" + (objJson.OrderId == null || objJson.OrderId == "" ? "" : " - " + objJson.OrderId));
          LODOP.SET_PRINT_PAGESIZE(0, "76mm", "130mm", "");

          /* 订单编号 */
          LODOP.ADD_PRINT_BARCODE("25mm", "8mm", "60mm", "15mm", "128C", objJson.OrderCode);
		  
		  /* 货物清单 */
		  LODOP.ADD_PRINT_TEXT("60mm", "10mm", "60mm", "65mm", objJson.ListInfo);
		  LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
		  LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
		  LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-1");		  
		  
        }
          break;
        case 2:
        default:
        {
          LODOP.PRINT_INITA("0mm", "0mm", "76mm", "130mm", "订单一联单" + (objJson.OrderId == null || objJson.OrderId == "" ? "" : " - " + objJson.OrderId));
          LODOP.SET_PRINT_PAGESIZE(0, "76mm", "130mm", "");

          /*订单编号*/
          LODOP.ADD_PRINT_BARCODE("25mm", "8mm", "60mm", "15mm", "128C", objJson.OrderCode);
		  
		  /* 货物清单 */
		  LODOP.ADD_PRINT_TEXT("60mm", "10mm", "60mm", "65mm", objJson.ListInfo);
		  LODOP.SET_PRINT_STYLEA(0, "FontName", "黑体");
		  LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
		  LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "-1");
		  
        }
          break;
      }

      if (this.findMachine || (!this.findMachine && this.getPrinter(objJson))) {
        switch (that.a.EBill.printType) {
          case 1: /*预览*/
            LODOP.PREVIEW();
            break;
          case 2: /*打印*/
            // LODOP.PRINT();

            // 打印并获取打印任务号
            var printTaskId = LODOP.PRINT();
            // 监听打印完成状态
            LODOP.On_Return=function(TaskID, Value){//TaskID:任务id，Value：job代码
              if (TaskID === printTaskId) {
                // 打印完成
                if(Value){
                  alert("打印成功");
                }else {
                  alert("打印失败");
                }
              }
            };
            break;
        }
      }
    },
    /*
    * 预览
    */
    toPreview: function (jsonStr, callBack) {
      this.doPrint(1, jsonStr, callBack);
    },
    /*
    * 打印
    */
    toPrint: function (jsonStr, callBack) {
      this.doPrint(2, jsonStr, callBack);
    },
    /*
    type：1-预览；2-打印
    */
    doPrint: function (type, printData, callBack) {
      that.a.EBill.printType = type;
      that.a.EBill.callBack = callBack;
      if (!!printData) {
        let jsons;
        switch (Object.prototype.toString.call(printData)) {
          case '[object String]':
            jsons = eval('(' + printData + ')');
            break;
          case '[object Array]':
          case '[object Object]':
            jsons = printData;
            break;
          default:
            return;
        }
        if (Object.prototype.toString.call(jsons) === '[object Array]') {
          if (jsons.length == 0) {
            return;
          }

          let objFirst = jsons[0];
          that.a.EBill.templateType = objFirst.TemplateType;

          if (objFirst.CloudPrint && (objFirst.CloudPrint == '1')) {
            let cloudType = that.a.EBill.getCloudType(objFirst.EBillType);
            for (let i = 0; i < jsons.length; i++) {
              jsons[i] = that.a.EBill.updatePrint(jsons[i]);
            }
            that.a.EBill.objJson = jsons;
            this.realPrint(cloudType);
          } else {
            for (let i = 0; i < jsons.length; i++) {
              jsons[i] = that.a.EBill.updatePrint(jsons[i]);

              that.a.EBill.objJson = jsons[i];
              this.realPrint();
            }

            if (typeof (callBack) == 'function') {
              callBack();
            }
          }
        }
        else {
          that.a.EBill.templateType = jsons.TemplateType;

          if (jsons.CloudPrint && (jsons.CloudPrint == '1')) {
            let cloudType = that.a.EBill.getCloudType(jsons.EBillType);
            let listJson = new Array();
            jsons = that.a.EBill.updatePrint(jsons);
            listJson.push(jsons);
            that.a.EBill.objJson = listJson;

            this.realPrint(cloudType);
          } else {
            jsons = that.a.EBill.updatePrint(jsons);

            that.a.EBill.objJson = jsons;
            this.realPrint();

            if (typeof (callBack) == 'function') {
              callBack();
            }
          }
        }
      }
    },
    /*
    * 检查是否安装打印控件
    */
    updatePrint: function (obj) {
      let isCod = obj.ServCodAmount && obj.ServCodAmount != "";

      /* 面单信息需要特殊处理 */
      if(obj.ListInfo){
        obj.ListInfo = obj.ListInfo.replace(/\|/g, '\n');
        if (isCod) {
          obj.ListInfo += "（支持开箱验货）";
        }
      }

      return obj;
    },
    /*
    * 获取打印类型
    */
    getCloudType: function (ebillType) {
      let cloudType;
      switch (ebillType) {
        case "6":
        case "7":
          cloudType = 1;
          break;
        case "9":
          cloudType = 2;
          break;
        case "12":/* 抖音小店 */
        case "13":/* 抖店代发 */
            cloudType = 3;
            break;
        default:
          cloudType = 0;
          break;
      }

      return cloudType;
    },
    /*
    * 检查是否安装打印控件
    */
    getPrinter: function () {
      let printObj = null;
      try {
        printObj = that.a.EBill.getLodop(document.getElementById('LODOP_OB'), document.getElementById('LODOP_EM'));
      } catch (err) {
        alert("检测到系统尚未安装Lodop打印控件，请下载安装！");
        return null;
      }

      if (printObj != null && typeof (printObj.VERSION) != "undefined") {
        printObj.SET_PRINT_MODE("TRYLINKPRINTER_NOALERT", false);

        let findPrinter = false;
        let printerCount = printObj.GET_PRINTER_COUNT();
        for (let idx = 0; idx < printerCount; idx++) {
          if (printObj.GET_PRINTER_NAME(idx).indexOf(that.a.EBill.printerKeyName) > -1) {
            if (printObj.SET_PRINTER_INDEX(idx)) {
              printObj.SET_PRINT_MODE("TRYLINKPRINTER_NOALERT", true); /*这个语句设置网络共享打印机连接不通时是否提示一下*/
              findPrinter = true;
              break;
            }
          }
        }

        if (!findPrinter) {
          alert("您尚未连接到电子面单打印机！");
          printObj = null;
        }
      } else {
        alert("检测到系统尚未安装打印控件，请下载安装！");
        printObj = null;
      }

      return printObj;
    },
    //==判断是否需要CLodop(那些不支持插件的浏览器):==
     needCLodop:function (){
    try {
      let ua = navigator.userAgent;
      if (ua.match(/Windows\sPhone/i))
        return true;
      if (ua.match(/iPhone|iPod|iPad/i))
        return true;
      if (ua.match(/Android/i))
        return true;
      if (ua.match(/Edge\D?\d+/i))
        return true;

      let verTrident = ua.match(/Trident\D?\d+/i);
      let verIE = ua.match(/MSIE\D?\d+/i);
      let verOPR = ua.match(/OPR\D?\d+/i);
      let verFF = ua.match(/Firefox\D?\d+/i);
      let x64 = ua.match(/x64/i);
      if ((!verTrident) && (!verIE) && (x64))
        return true;
      else if (verFF) {
        verFF = verFF[0].match(/\d+/);
        if ((verFF[0] >= 41) || (x64))
          return true;
      } else if (verOPR) {
        verOPR = verOPR[0].match(/\d+/);
        if (verOPR[0] >= 32)
          return true;
      } else if ((!verTrident) && (!verIE)) {
        let verChrome = ua.match(/Chrome\D?\d+/i);
        if (verChrome) {
          verChrome = verChrome[0].match(/\d+/);
          if (verChrome[0] >= 41)
            return true;
        }
      }
      return false;
    } catch (err) {
      return true;
    }
    },

    //==加载引用CLodop的主JS,用双端口8000和18000(以防其中一个被占):==
    loadCLodop:function() {
    if (that.a.CNPrint.CLodopJsState == "loading" || that.a.CNPrintCLodopJsState == "complete") return;
     that.a.CNPrintCLodopJsState = "loading";
    let head = document.head || document.getElementsByTagName("head")[0] || document.documentElement;
    let JS1 = document.createElement("script");
    let JS2 = document.createElement("script");
    JS1.src = "https://localhost:8443/CLodopfuncs.js?priority=1";//http://localhost:8000/CLodopfuncs.js?priority=1
    JS2.src = "http://localhost:18000/CLodopfuncs.js";
    JS1.onload  = JS2.onload  = function()    {that.a.CNPrintCLodopJsState = "complete";}
    JS1.onerror = JS2.onerror = function(evt) {that.a.CNPrintCLodopJsState = "complete";}
    head.insertBefore(JS1, head.firstChild);
    head.insertBefore(JS2, head.firstChild);
    that.a.CNPrint.CLodopIsLocal = !!((JS1.src + JS2.src).match(/\/\/localho|\/\/127.0.0./i));
    },



    //==获取LODOP对象主过程,判断是否安装、需否升级:==
    getLodop:function(oOBJECT, oEMBED) {
    let strHtmInstall = "<br><font color='#FF00FF'>打印控件未安装!点击这里<a href='install_lodop32.exe' target='_self'>执行安装</a>,安装后请刷新页面或重新进入。</font>";
    let strHtmUpdate = "<br><font color='#FF00FF'>打印控件需要升级!点击这里<a href='install_lodop32.exe' target='_self'>执行升级</a>,升级后请重新进入。</font>";
    let strHtm64_Install = "<br><font color='#FF00FF'>打印控件未安装!点击这里<a href='install_lodop64.exe' target='_self'>执行安装</a>,安装后请刷新页面或重新进入。</font>";
    let strHtm64_Update = "<br><font color='#FF00FF'>打印控件需要升级!点击这里<a href='install_lodop64.exe' target='_self'>执行升级</a>,升级后请重新进入。</font>";
    let strHtmFireFox = "<br><br><font color='#FF00FF'>（注意：如曾安装过Lodop旧版附件npActiveXPLugin,请在【工具】->【附加组件】->【扩展】中先卸它）</font>";
    let strHtmChrome = "<br><br><font color='#FF00FF'>(如果此前正常，仅因浏览器升级或重安装而出问题，需重新执行以上安装）</font>";
    let strCLodopInstall_1 = "<br><font color='#FF00FF'>Web打印服务CLodop未安装启动，点击这里<a href='CLodop_Setup_for_Win32NT.exe' target='_self'>下载执行安装</a>";
    let strCLodopInstall_2 = "<br>（若此前已安装过，可<a href='CLodop.protocol:setup' target='_self'>点这里直接再次启动</a>）";
    let strCLodopInstall_3 = "，成功后请刷新本页面。</font>";
    let strCLodopUpdate = "<br><font color='#FF00FF'>Web打印服务CLodop需升级!点击这里<a href='CLodop_Setup_for_Win32NT.exe' target='_self'>执行升级</a>,升级后请刷新页面。</font>";
    let LODOP;
    try {
      let ua = navigator.userAgent;
      let isIE = !!(ua.match(/MSIE/i)) || !!(ua.match(/Trident/i));
      if (that.a.EBill.needCLodop()) {
        try {
          LODOP = getCLodop();
        } catch (err) {}
        if (!LODOP && that.a.CNPrintCLodopJsState !== "complete") {
          if (that.a.CNPrintCLodopJsState == "loading") alert("网页还没下载完毕，请稍等一下再操作."); else alert("没有加载CLodop的主js，请先调用loadCLodop过程.");
          return;
        }
        if (!LODOP) {
          document.body.innerHTML = strCLodopInstall_1 + (that.a.CNPrint.CLodopIsLocal ? strCLodopInstall_2 : "") + strCLodopInstall_3 + document.body.innerHTML;
          return;
        } else {
          if (CLODOP.CVERSION < "4.1.2.7") {
            document.body.innerHTML = strCLodopUpdate + document.body.innerHTML;
          }
          if (oEMBED && oEMBED.parentNode)
            oEMBED.parentNode.removeChild(oEMBED); //清理旧版无效元素
          if (oOBJECT && oOBJECT.parentNode)
            oOBJECT.parentNode.removeChild(oOBJECT);
        }
      } else {
        let is64IE = isIE && !!(ua.match(/x64/i));
        //==如果页面有Lodop就直接使用,否则新建:==
        if (oOBJECT || oEMBED) {
          if (isIE)
            LODOP = oOBJECT;
          else
            LODOP = oEMBED;
        } else if (!that.a.CNPrint.CreatedOKLodopObject) {
          LODOP = document.createElement("object");
          LODOP.setAttribute("width", 0);
          LODOP.setAttribute("height", 0);
          LODOP.setAttribute("style", "position:absolute;left:0px;top:-100px;width:0px;height:0px;");
          if (isIE)
            LODOP.setAttribute("classid", "clsid:2105C259-1E0C-4534-8141-A753534CB4CA");
          else
            LODOP.setAttribute("type", "application/x-print-lodop");
          document.documentElement.appendChild(LODOP);
          that.a.CNPrint.CreatedOKLodopObject = LODOP;
        } else
          LODOP = that.a.CNPrint.CreatedOKLodopObject;
        //==Lodop插件未安装时提示下载地址:==
        if ((!LODOP) || (!LODOP.VERSION)) {
          if (ua.indexOf('Chrome') >= 0)
            document.body.innerHTML = strHtmChrome + document.body.innerHTML;
          if (ua.indexOf('Firefox') >= 0)
            document.body.innerHTML = strHtmFireFox + document.body.innerHTML;
          document.body.innerHTML = (is64IE ? strHtm64_Install : strHtmInstall) + document.body.innerHTML;
          return LODOP;
        }
      }
      if (LODOP.VERSION < "6.2.2.6") {
        if (!that.a.EBill.needCLodop())
          document.body.innerHTML = (is64IE ? strHtm64_Update : strHtmUpdate) + document.body.innerHTML;
      }
      //===如下空白位置适合调用统一功能(如注册语句、语言选择等):==
      LODOP.SET_LICENSES("杭州易万贝网络有限公司", "964717562827589907689190562356", "", "");
      //=======================================================
      return LODOP;
    } catch (err) {
      alert("getLodop出错:" + err);
    }
    },


    /*
    * 执行真正的打印
    */
    realPrint: function (cloudType) {
      switch (cloudType) {
        case 1: {
          /* 强制使用菜鸟电子面单云打印 */
          if (!that.a.CNPrint.cnSocket || that.a.CNPrint.cnSocket.readyState != 1) {
            that.a.CNPrint.connectting();
          } else {
            if (that.a.CNPrint.defaultPrinter) {
              that.a.CNPrint.getPrinterConfig();
            } else {
              alert('未启用【菜鸟打印组件】,无法打印电子面单！');
            }
          }
        }
          break;
        case 2: {
          /* 强制使用拼多多电子面单云打印 */
          if (!that.a.PDDPrint.pddSocket || that.a.PDDPrint.pddSocket.readyState != 1) {
            that.a.PDDPrint.connectting();
          } else {
            if (that.a.PDDPrint.defaultPrinter) {
              that.a.PDDPrint.getPrinterConfig();
            } else {
              alert('未启用【拼多多打印组件】,无法打印电子面单！');
            }
          }
        }
          break;
        case 3: {
            /* 强制使用抖店电子面单云打印 */
            if (!that.a.DDPrint.ddSocket || that.a.DDPrint.ddSocket.readyState != 1) {
                that.a.DDPrint.connectting();
            } else {
                if (that.a.DDPrint.defaultPrinter) {
                    //that.a.DDPrint.getPrinterConfig();
                    that.a.DDPrint.print()
                } else {
                    alert('未启用【抖店打印组件】,无法打印电子面单！');
                }
            }
        }
            break;
        default: {
          let printData = that.a.EBill.objJson;

          /* 没安装控件则退出 */
          let printer = this.getPrinter();
          if (printer == null) {
            return;
          }

          //用第0个来判断
          let printData0 = printData;
          if (Object.prototype.toString.call(printData) === '[object Array]') {
               printData0 = printData[0];
          }

          if (printData0.EBillType == '0') {
            /* 只打印订单编号 */
            this.OrderPrint(printer, printData0);
          } else if (printData0.CpCode == 'SF') {
            /* 顺丰面单打印 */
            if (printData0.AccessType == 'FengQiao' || printData0.SfWaybillInfo) {
              this.FengQiaoPrint(printer, printData);
            } else {
              this.ShunFengPrint(printer, printData);
            }
          } else if (printData0.CpCode == 'JINGDONG') {
            /* 京东快递面单打印 */
            this.JingDongPrint(printer, printData);
          } else if (printData0.CpCode == 'YTO' && (printData0.EBillType == '3' || printData0.EBillType == '4')) {
            /* 圆通京东or圆通代收货款面单打印 */
            this.YtoPrint(printer, printData);
            /*
            } else if (printData.CpCode == 'CN7000001000869') {
                //安能快运
                this.AnnengPrint(printer, printData);
            */
          } else if (printData0.CpCode == '2608021499_235') {
            /* 安能物流面单打印 */
            this.AnnePrint(printer, printData);
          } else {
            /* 使用Lodop打印通用面单 */
            this.LodopPrint(printer, printData);
          }
        }
          break;
      }
    }
    },

    /*
    调用方式:

    预览
    EBill.toPreview(jsonStr);

    打印
    EBill.toPrint(jsonStr);
    */
}

export  default CN




// WEBPACK FOOTER //
// ./src/utils/CN.js